import { useFormik } from "formik";
import {
  TextField,
  MenuItem,
  Button,
  Grid,
  Typography,
  Box,
  Breadcrumbs,
  Divider,
  Card,
  IconButton,
  Autocomplete,
  InputLabel,
  FormControl,
  Select,
  OutlinedInput,
  ListItemText,
  FormHelperText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Chip,
  Tooltip,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
  TableContainer,
  InputAdornment,
  ToggleButton,
  ToggleButtonGroup,
  Alert,
  Checkbox,
} from "@mui/material";
import PillToggle from "../../components/PillToggle";
import PaymentAttachmentUpload from "../../components/PaymentAttachmentUpload";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import Link from "@mui/material/Link";
import { useRef, useState, useMemo, useEffect, Fragment } from "react";
import Layout from "../../layout/Layout";
import { AlertMessage } from "../../components/AlertMessage";
import ReservationImpactTable from "../../components/ReservationImpactTable";
import { computeReservationImpact } from "../../utils/reservationImpact";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { apiData } from "../../services/api_service";
import {
  fetchProductDropdownAPI,
  fetchProductUnitAPI,
  termsAndConditionsAPI,
  storesDropdownAPI,
  fetchProductsByStoreAPI,
  fetchCustomerDDAPI,
  generateProformaAPI,
  proformaBaseAPI,
  generateProformaQuoteAPI,
  proformaQuoteBaseAPI,
  productAvailabilityAPI,
  fetchBundlesAPI,
  uploadToVercelAPI,
  creditApprovalBaseAPI,
  bundleAvailabilityAllStoresAPI,
  insertCreditApprovalAPI,
} from "../../config";
import CloseIcon from "@mui/icons-material/Close";
import * as Yup from "yup";
import dayjs from "dayjs";
import { emirates } from "../../components/constants";
import { formatAED } from "../../utils/format";
import { discountAmountFromPercent, sanitizePercentInput } from "../../utils/discount";
import { LoadingButton } from "@mui/lab";
import { Backdrop, CircularProgress } from "@mui/material";

const countryCodes = [
  // Middle East & GCC
  { code: "+971", label: "+971 (UAE)" },
  { code: "+966", label: "+966 (Saudi Arabia)" },
  { code: "+968", label: "+968 (Oman)" },
  { code: "+973", label: "+973 (Bahrain)" },
  { code: "+965", label: "+965 (Kuwait)" },
  { code: "+974", label: "+974 (Qatar)" },
  { code: "+20", label: "+20 (Egypt)" },
  { code: "+962", label: "+962 (Jordan)" },
  { code: "+961", label: "+961 (Lebanon)" },
  { code: "+964", label: "+964 (Iraq)" },
  { code: "+98", label: "+98 (Iran)" },
  { code: "+963", label: "+963 (Syria)" },
  { code: "+967", label: "+967 (Yemen)" },
  { code: "+970", label: "+970 (Palestine)" },
  { code: "+90", label: "+90 (Turkey)" },
  { code: "+357", label: "+357 (Cyprus)" },

  // South Asia
  { code: "+91", label: "+91 (India)" },
  { code: "+92", label: "+92 (Pakistan)" },
  { code: "+880", label: "+880 (Bangladesh)" },
  { code: "+94", label: "+94 (Sri Lanka)" },
  { code: "+977", label: "+977 (Nepal)" },
  { code: "+93", label: "+93 (Afghanistan)" },
  { code: "+960", label: "+960 (Maldives)" },
  { code: "+975", label: "+975 (Bhutan)" },

  // East & Southeast Asia
  { code: "+86", label: "+86 (China)" },
  { code: "+852", label: "+852 (Hong Kong)" },
  { code: "+853", label: "+853 (Macao)" },
  { code: "+886", label: "+886 (Taiwan)" },
  { code: "+81", label: "+81 (Japan)" },
  { code: "+82", label: "+82 (South Korea)" },
  { code: "+65", label: "+65 (Singapore)" },
  { code: "+60", label: "+60 (Malaysia)" },
  { code: "+66", label: "+66 (Thailand)" },
  { code: "+62", label: "+62 (Indonesia)" },
  { code: "+63", label: "+63 (Philippines)" },
  { code: "+84", label: "+84 (Vietnam)" },
  { code: "+95", label: "+95 (Myanmar)" },
  { code: "+855", label: "+855 (Cambodia)" },
  { code: "+856", label: "+856 (Laos)" },
  { code: "+673", label: "+673 (Brunei)" },
  { code: "+976", label: "+976 (Mongolia)" },

  // Central Asia & Caucasus
  { code: "+7", label: "+7 (Kazakhstan / Russia)" },
  { code: "+998", label: "+998 (Uzbekistan)" },
  { code: "+993", label: "+993 (Turkmenistan)" },
  { code: "+996", label: "+996 (Kyrgyzstan)" },
  { code: "+992", label: "+992 (Tajikistan)" },
  { code: "+994", label: "+994 (Azerbaijan)" },
  { code: "+374", label: "+374 (Armenia)" },
  { code: "+995", label: "+995 (Georgia)" },

  // Americas & Caribbean
  { code: "+1", label: "+1 (USA / Canada)" },
  { code: "+52", label: "+52 (Mexico)" },
  { code: "+55", label: "+55 (Brazil)" },
  { code: "+54", label: "+54 (Argentina)" },
  { code: "+57", label: "+57 (Colombia)" },
  { code: "+56", label: "+56 (Chile)" },
  { code: "+51", label: "+51 (Peru)" },
  { code: "+58", label: "+58 (Venezuela)" },
  { code: "+593", label: "+593 (Ecuador)" },
  { code: "+591", label: "+591 (Bolivia)" },
  { code: "+595", label: "+595 (Paraguay)" },
  { code: "+598", label: "+598 (Uruguay)" },
  { code: "+506", label: "+506 (Costa Rica)" },
  { code: "+507", label: "+507 (Panama)" },
  { code: "+502", label: "+502 (Guatemala)" },
  { code: "+504", label: "+504 (Honduras)" },
  { code: "+503", label: "+503 (El Salvador)" },
  { code: "+505", label: "+505 (Nicaragua)" },
  { code: "+53", label: "+53 (Cuba)" },
  { code: "+1809", label: "+1-809 (Dominican Republic)" },
  { code: "+1787", label: "+1-787 (Puerto Rico)" },
  { code: "+1876", label: "+1-876 (Jamaica)" },
  { code: "+1868", label: "+1-868 (Trinidad & Tobago)" },

  // Europe
  { code: "+44", label: "+44 (UK)" },
  { code: "+49", label: "+49 (Germany)" },
  { code: "+33", label: "+33 (France)" },
  { code: "+39", label: "+39 (Italy)" },
  { code: "+34", label: "+34 (Spain)" },
  { code: "+351", label: "+351 (Portugal)" },
  { code: "+31", label: "+31 (Netherlands)" },
  { code: "+32", label: "+32 (Belgium)" },
  { code: "+41", label: "+41 (Switzerland)" },
  { code: "+43", label: "+43 (Austria)" },
  { code: "+353", label: "+353 (Ireland)" },
  { code: "+45", label: "+45 (Denmark)" },
  { code: "+47", label: "+47 (Norway)" },
  { code: "+46", label: "+46 (Sweden)" },
  { code: "+358", label: "+358 (Finland)" },
  { code: "+354", label: "+354 (Iceland)" },
  { code: "+48", label: "+48 (Poland)" },
  { code: "+420", label: "+420 (Czech Republic)" },
  { code: "+421", label: "+421 (Slovakia)" },
  { code: "+36", label: "+36 (Hungary)" },
  { code: "+40", label: "+40 (Romania)" },
  { code: "+359", label: "+359 (Bulgaria)" },
  { code: "+30", label: "+30 (Greece)" },
  { code: "+385", label: "+385 (Croatia)" },
  { code: "+381", label: "+381 (Serbia)" },
  { code: "+386", label: "+386 (Slovenia)" },
  { code: "+387", label: "+387 (Bosnia & Herzegovina)" },
  { code: "+355", label: "+355 (Albania)" },
  { code: "+380", label: "+380 (Ukraine)" },
  { code: "+375", label: "+375 (Belarus)" },
  { code: "+370", label: "+370 (Lithuania)" },
  { code: "+371", label: "+371 (Latvia)" },
  { code: "+372", label: "+372 (Estonia)" },
  { code: "+356", label: "+356 (Malta)" },

  // Africa
  { code: "+27", label: "+27 (South Africa)" },
  { code: "+234", label: "+234 (Nigeria)" },
  { code: "+254", label: "+254 (Kenya)" },
  { code: "+233", label: "+233 (Ghana)" },
  { code: "+212", label: "+212 (Morocco)" },
  { code: "+213", label: "+213 (Algeria)" },
  { code: "+216", label: "+216 (Tunisia)" },
  { code: "+218", label: "+218 (Libya)" },
  { code: "+249", label: "+249 (Sudan)" },
  { code: "+251", label: "+251 (Ethiopia)" },
  { code: "+255", label: "+255 (Tanzania)" },
  { code: "+256", label: "+256 (Uganda)" },
  { code: "+250", label: "+250 (Rwanda)" },
  { code: "+221", label: "+221 (Senegal)" },
  { code: "+225", label: "+225 (Ivory Coast)" },
  { code: "+237", label: "+237 (Cameroon)" },
  { code: "+244", label: "+244 (Angola)" },
  { code: "+258", label: "+258 (Mozambique)" },
  { code: "+263", label: "+263 (Zimbabwe)" },
  { code: "+260", label: "+260 (Zambia)" },
  { code: "+230", label: "+230 (Mauritius)" },

  // Oceania & Pacific
  { code: "+61", label: "+61 (Australia)" },
  { code: "+64", label: "+64 (New Zealand)" },
  { code: "+675", label: "+675 (Papua New Guinea)" },
  { code: "+679", label: "+679 (Fiji)" },
];

const isKnownEmirate = (value) =>
  emirates.some((emirate) => emirate.name === value);

// UAE-specific format requirement removed (Item 8) — Contact Number is
// optional; only a loose generic sanity check applies when a value is typed.
const validateUaePhone = (value) => {
  if (!value) return true;
  const clean = value.replace(/[\s-]/g, "");
  const genericPhoneRegex = /^\+?\d{6,15}$/;
  if (!genericPhoneRegex.test(clean)) {
    return "Enter a valid phone number";
  }
  return true;
};

const isBundleProduct = (product) =>
  Number(product?.is_bundle) === 1 ||
  product?.color === "Bundle" ||
  product?.size === "Bundle";

// Upper bound for any single money field (price, discount, shipping). Generous
// for a real transaction, but stops stray/mashed keystrokes from producing
// absurd (even exponential-notation) totals.
const MAX_MONEY_VALUE = 9999999.99;

// Sanitizes free-typed money input: strips anything that isn't a digit or a
// decimal point, caps decimals at 2 places, and clamps to `max`. Always
// returns a usable value instead of silently rejecting the keystroke — a
// reject-and-return-early approach leaves the real input text out of sync
// with the value React thinks it set, letting more digits pile up uncapped
// on the next keystroke.
const sanitizeMoneyInput = (raw, max) => {
  let sanitized = String(raw).replace(/[^\d.]/g, "");
  const firstDot = sanitized.indexOf(".");
  if (firstDot !== -1) {
    sanitized =
      sanitized.slice(0, firstDot + 1) +
      sanitized.slice(firstDot + 1).replace(/\./g, "").slice(0, 2);
  }
  const numeric = parseFloat(sanitized);
  if (sanitized !== "" && !isNaN(numeric) && numeric > max) {
    return max.toFixed(2);
  }
  return sanitized;
};

// Everything that differs between the CDN (Consignment Delivery Note) and
// Proforma Invoice document types: API endpoints, the list page they return
// to, and the labels/titles shown on screen. All form behavior (validation,
// bundle handling, reservation-impact confirm, totals, etc.) is identical
// between the two, so it lives once in this component.
// Sanity cap on Credit Days — unbounded input overflows dayjs().add() into
// "Invalid Date" wherever a Due Date is derived from it.
const MAX_CREDIT_DAYS = 3650; // 10 years

const DOC_CONFIG = {
  cdn: {
    generateApi: generateProformaAPI,
    baseApi: proformaBaseAPI,
    listPath: "/proforma-invoice/list",
    docLabel: "Consignment Delivery Note",
    pageTitle: "Consignment Delivery Note (CDN)",
    editPageTitle: "Edit Consignment Delivery Note (CDN)",
    sectionTitle: "CDN Details",
    docNoLabel: "CDN No",
    confirmTitle: "Confirm CDN",
    confirmTitleEdit: "Confirm CDN Changes",
    confirmButtonCreate: "Generate CDN",
    submitButtonCreate: "Generate Consignment Delivery Note",
    submitButtonUpdate: "Update Consignment Delivery Note",
  },
  proforma: {
    generateApi: generateProformaQuoteAPI,
    baseApi: proformaQuoteBaseAPI,
    listPath: "/proforma-quote/list",
    docLabel: "Proforma Invoice",
    pageTitle: "Proforma Invoice",
    editPageTitle: "Edit Proforma Invoice",
    sectionTitle: "Proforma Details",
    docNoLabel: "Proforma No",
    confirmTitle: "Confirm Proforma",
    confirmTitleEdit: "Confirm Proforma Changes",
    confirmButtonCreate: "Generate Proforma",
    submitButtonCreate: "Generate Proforma Invoice",
    submitButtonUpdate: "Update Proforma Invoice",
  },
};

const DeliveryNoteForm = ({ variant = "cdn" }) => {
  const cfg = DOC_CONFIG[variant] || DOC_CONFIG.cdn;
  const user = JSON.parse(localStorage.getItem("user"));
  const alertRef = useRef(null);

  const navigate = useNavigate();
  const { id } = useParams();
  const isEdit = Boolean(id);
  // Re-submitting a credit request Admin rejected: /…/add?resubmit=<request id>
  // reopens the form pre-filled (creator only — the server enforces it).
  const [searchParams] = useSearchParams();
  const resubmitId = searchParams.get("resubmit");
  const [resubmitInfo, setResubmitInfo] = useState(null);

  // Original items loaded in edit mode, used to compute the reservation delta
  // when the user submits changes.
  const originalItemsRef = useRef([]);
  // The proforma's document number (edit mode) — shown in the confirm dialog.
  const [proformaNumber, setProformaNumber] = useState("");
  // Edit mode: was this document already approved for credit when opened?
  const [wasCredit, setWasCredit] = useState(false);
  // Why the user is asking for credit — shown to Admin alongside the
  // document, kept separate from the document's own Notes field.
  const [creditReason, setCreditReason] = useState("");
  // { values, impact, impactLoading } while the edit-impact dialog is open.
  const [editConfirm, setEditConfirm] = useState(null);
  const [editSubmitting, setEditSubmitting] = useState(false);

  const [productList, setProductList] = useState([]);
  // True while fetchProductsWithStock is in flight *for a store change*
  // specifically (not for a keystroke search — see the two call sites below)
  // — used to keep the product picker disabled until the fresh store's stock
  // has actually loaded, instead of letting openOnFocus pop it open showing
  // whatever the previous store's (or the initial no-store) list was.
  const [productListLoading, setProductListLoading] = useState(false);
  const [bundleList, setBundleList] = useState([]);
  const [selectionMode, setSelectionMode] = useState("product");
  // On-demand cross-store lookup for an out-of-stock bundle: bundleId ->
  // { loading, byStore }. Fetched lazily, only when staff click "Check other
  // stores" on that specific bundle, so it stays cheap no matter how many
  // stores or bundles exist.
  const [bundleStoreAvailability, setBundleStoreAvailability] = useState({});
  const checkBundleOtherStores = async (bundleProductId) => {
    setBundleStoreAvailability((prev) => ({
      ...prev,
      [bundleProductId]: { loading: true, byStore: [] },
    }));
    try {
      const res = await apiData(
        "get",
        `${bundleAvailabilityAllStoresAPI}/${bundleProductId}`
      );
      setBundleStoreAvailability((prev) => ({
        ...prev,
        [bundleProductId]: {
          loading: false,
          byStore: res.success ? res.data?.byStore || [] : [],
        },
      }));
    } catch (e) {
      console.error("Failed to fetch bundle availability across stores:", e);
      setBundleStoreAvailability((prev) => ({
        ...prev,
        [bundleProductId]: { loading: false, byStore: [] },
      }));
    }
  };
  const [bundleDetails, setBundleDetails] = useState(null);
  const [customerList, setCustomerList] = useState([]);
  const [searchTerm, setSearchTerm] = useState([""]);
  const [storeOptions, setStoreOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const validationSchema = Yup.object({
    orderDate: Yup.string().required("Order Date is required"),
    name: Yup.string()
      .required("Customer Name is required")
      .min(2, "Minimum 2 characters")
      .max(200, "Maximum 200 characters"),

    // Mirrors the Customer Master form ([[Customers.jsx]]) — a new customer
    // typed directly on this form (i.e. no existing customer picked from the
    // "Select Customer" dropdown) is auto-created in tbl_customers on submit
    // (see orderMasterModel.js insertCustomer), so it needs the same
    // Individual/Company classification the master form collects, instead of
    // silently defaulting to "Company" on the backend.
    customer_type: Yup.string().required("Customer type is required"),
    // Only required when creating a new customer here. An existing customer
    // selected from the dropdown may predate the Company Name field on
    // Customer Master and simply have none on file — don't block the
    // document on filling in master-data that this form isn't responsible for.
    company_name: Yup.string().when(["customer_type", "customer_id"], {
      is: (customer_type, customer_id) => customer_type === "Company" && !customer_id,
      then: (schema) =>
        schema
          .required("Company Name is required")
          .max(255, "Maximum 255 characters"),
      otherwise: (schema) => schema.notRequired(),
    }),

    phone_number: Yup.string()
      .nullable()
      .test("valid-phone", (value, ctx) => {
        const result = validateUaePhone(value);
        return result === true ? true : ctx.createError({ message: result });
      }),

    // Email is optional — format check accepts all domains (.ae, .com, .org, etc.)
    email: Yup.string()
      .nullable()
      .test("valid-email", "Enter a valid email address", (value) => {
        if (!value) return true;
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      }),

    address: Yup.string()
      .nullable()
      .max(300, "Maximum 300 characters"),

    emirate: Yup.string().nullable(),
    items: Yup.array()
      .of(
        Yup.object().shape({
          productId: Yup.string().nullable().required("Product is required"),
          sellingPrice: Yup.number()
            .required("Selling price is required")
            .moreThan(0, "Must be greater than 0")
            .max(MAX_MONEY_VALUE, "Selling price is too large")
            .test("is-greater", function (value) {
              const { buyingPrice } = this.parent;

              if (!buyingPrice) return true;
              if (Number(value) < Number(buyingPrice)) {
                return this.createError({
                  message: `Selling price (${value}) cannot be lesser than buying price (${buyingPrice})`,
                });
              }
              return true;
            }),
          quantity: Yup.number()
            .transform((value, originalValue) =>
              String(originalValue).trim() === "" ? null : value
            )
            .nullable()
            .required("Quantity is required")
            .typeError("Quantity must be number")
            .moreThan(0, "Must be greater than 0"),
          subtotal: Yup.number()
            .required("Subtotal is required")
            .min(0, "Cannot be negative"),
          buyingPrice: Yup.number().nullable(),
        })
      )
      .min(1, "At least 1 product must be selected"),

    // Customer's VAT No. — auto-filled from the selected customer's own
    // vat_no (see the customer-select handler below) and shown/editable as
    // "VAT No." rather than "TRN" (see [[trn-to-vat-no-rename]] — the
    // customer record itself no longer collects a TRN either).
    vat_no: Yup.string().matches(/^[0-9]*$/, "Only numbers are allowed"),

    taxAmount: Yup.number()
      .required("Tax amount is required")
      .min(0, "Cannot be negative"),

    discount: Yup.number()
      .min(0, "Cannot be negative")
      .max(MAX_MONEY_VALUE, "Discount is too large")
      .test(
        "not-more-than-subtotal",
        "Discount cannot exceed the subtotal",
        function (value) {
          const items = this.parent.items || [];
          const subtotal = items.reduce(
            (sum, row) => sum + (parseFloat(row.subtotal) || 0),
            0
          );
          return (parseFloat(value) || 0) <= subtotal;
        }
      ),

    shippingCharges: Yup.number()
      .min(0, "Cannot be negative")
      .max(MAX_MONEY_VALUE, "Shipping charges is too large"),

    term_id: Yup.string().required("Terms & Conditions is required"),
    paymentMethod: Yup.string().when("payment_type", {
      is: 2,
      then: (schema) => schema.required("Payment Method is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    payment_type: Yup.number().required("Payment Type is required"),
    store_id: Yup.number().required("Store is required"),
  });

  const formik = useFormik({
    initialValues: {
      orderDate: dayjs().format("YYYY-MM-DD"),
      customer_id: null,
      store_id: "",
      salesman_id: "",
      name: "",
      customer_type: "Company",
      company_name: "",
      billToCompany: "",
      creditApprovedBy: "",
      discountPercent: "",
      countryCode: "+971",
      phone_number: "",
      email: "",
      address: "",
      vat_no: "",
      po_box: "",
      emirate: "",
      emirateOption: "",
      items: [{ productId: "", sellingPrice: 0, quantity: 0, subtotal: 0 }],
      taxType: "5",
      taxMode: "exclusive", // "exclusive" (VAT added on top) | "inclusive" (VAT embedded in price)
      taxAmount: 0,
      shippingCharges: 0,
      discount: 0,
      // "item" = Item-wise Discount (per product row), "total" = Total Special
      // Discount (single value on the whole transaction). Products only —
      // bundles keep their own separate discount mode. Mutually exclusive
      // per Item 3's requirement.
      discountType: "item",
      bundleDiscount: 0,
      payment_type: "",
      paymentMethod: "",
      // Advance payments received now (CDN create only) — each {payment_method, amount, transaction_id}.
      advances: [],
      paymentReferenceNo: "",
      paymentAttachmentUrl: "",
      paymentAttachmentName: "",
      paymentAttachmentUploading: false,
      creditDays: "",
      dueDate: dayjs().format("YYYY-MM-DD"),
      notes: "",
      term_id: "",
      terms: "",
      trn_number: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      const hasOutOfStock = values.items.some((item) => {
        const product = productList.find((p) => p.id === item.productId);
        return product && !product.inStock;
      });

      if (hasOutOfStock) {
        alertRef.current.triggerAlert(
          JSON.stringify({
            message: `You cannot generate a ${cfg.docLabel} with out-of-stock products.`,
            messageType: "error",
          })
        );
        return;
      }

      // Preview the reservation impact and confirm before creating or saving.
      openSubmitConfirm(values);
    },
  });

  // Performs the actual create/update API call.
  const submitProforma = async (values) => {
    try {
      setLoading(true);
      values.user_id = user.emp_id;

      // Bundle discounts (bundle-wide or per-item) stay fully hidden on the
      // printed CDN: fold into a NET unit price (subtotal ÷ qty) so it reads
      // as price × qty = line total with no discount shown. A plain
      // product's discount is real customer-facing information, so it's
      // kept visible instead — sellingPrice stays the actual (gross) price
      // and the discount amount rides along separately for the PDF to print
      // as its own column.
      const payload = {
        ...values,
        items: values.items.map((item) => {
          if (item.fromBundle) {
            const qty = parseFloat(item.quantity) || 0;
            const net = parseFloat(item.subtotal) || 0;
            const netUnit = qty > 0 ? net / qty : 0;
            return { ...item, sellingPrice: Number(netUnit.toFixed(2)) };
          }
          // discountPercent is a 0-100 % now — backend's discount_amount
          // column still stores an actual currency value. Prefer the AED
          // value the user actually typed (discountValue) over recomputing
          // it from the rounded % — e.g. AED 10 on a 150 line rounds to a
          // displayed 6.67%, and 150 × 6.67% comes back as 10.005 → 10.01,
          // not the original 10.00. Only fall back to computing from %
          // when that's genuinely what was entered (or discountValue is
          // missing, e.g. an older record).
          const gross =
            (parseFloat(item.sellingPrice) || 0) * (parseFloat(item.quantity) || 0);
          const discountValueNum = parseFloat(item.discountValue);
          const discountAmt =
            item.discountUnit === "percent" || Number.isNaN(discountValueNum)
              ? discountAmountFromPercent(gross, item.discountPercent)
              : discountValueNum;
          return discountAmt > 0
            ? { ...item, discount_amount: Number(discountAmt.toFixed(2)) }
            : item;
        }),
      };

      if (variant === "cdn" && !isEdit) {
        const advRows = (values.advances || []).filter(
          (a) => a.payment_method || parseFloat(a.amount) > 0
        );
        if (advRows.some((a) => a.uploading)) {
          alertRef.current.triggerAlert(
            JSON.stringify({ message: "Please wait for the attachment to finish uploading.", messageType: "warning" })
          );
          return;
        }
        const bad = advRows.find((a) => !a.payment_method || !(parseFloat(a.amount) > 0));
        const advTotal = advRows.reduce((t, a) => t + (parseFloat(a.amount) || 0), 0);
        if (bad || advTotal > (parseFloat(values.grandTotal) || 0) + 0.009) {
          alertRef.current.triggerAlert(
            JSON.stringify({
              message: bad
                ? "Each advance payment needs a method and an amount."
                : "Advance payments cannot exceed the Grand Total.",
              messageType: "error",
            })
          );
          return;
        }
        payload.advances = advRows.map((a) => ({
          payment_method: a.payment_method,
          amount: parseFloat(a.amount),
          transaction_id: a.transaction_id || null,
          attachment_url: a.attachment_url || null,
          attachment_name: a.attachment_name || null,
        }));
        // Advance covers everything -> Immediate Payment, no credit approval.
        if (String(values.payment_type) === "1" && advTotal > 0 &&
            advTotal >= (parseFloat(values.grandTotal) || 0) - 0.009 &&
            (parseFloat(values.grandTotal) || 0) > 0) {
          payload.payment_type = 2;
          payload.paymentMethod = advRows[0].payment_method;
          payload.creditDays = "";
          payload.dueDate = null;
        }
      }

      // Credit is approved per document: a NEW credit document isn't created
      // here — its full form is sent to Admin as a draft, and the server
      // only creates it once Admin approves. The confirm step already told
      // the user this is happening (see the ConfirmDialog content below), so
      // this just does it — no second popup.
      if (!isEdit && String(payload.payment_type) === "1") {
        if (!values.customer_id) {
          alertRef.current.triggerAlert(
            JSON.stringify({
              message:
                "Select an existing customer from the list to request credit terms.",
              messageType: "warning",
            })
          );
          return;
        }
        const creditResult = await apiData("post", insertCreditApprovalAPI, {
          customer_id: values.customer_id,
          requested_days: Number(values.creditDays) || 15,
          notes: creditReason || "",
          doc_type: variant === "proforma" ? "proforma" : "cdn",
          resubmit_of: resubmitInfo?.request_id || undefined,
          payload,
        });
        if (creditResult.success) {
          alertRef.current.triggerAlert(
            JSON.stringify({
              message: `Sent to Admin for credit approval. This ${cfg.docLabel} will be created once approved.`,
              messageType: "success",
            })
          );
          setTimeout(() => navigate("/credit-approval/list"), 1400);
        } else {
          alertRef.current.triggerAlert(
            JSON.stringify({
              message: creditResult.msg || "Failed to send the credit approval request.",
              messageType: "error",
            })
          );
        }
        return;
      }

      const result = isEdit
        ? await apiData("put", `${cfg.baseApi}/${id}`, payload)
        : await apiData("post", cfg.generateApi, payload);

      if (result.success) {
        alertRef.current.triggerAlert(
          JSON.stringify({
            message: isEdit
              ? `${cfg.docLabel} updated successfully.`
              : `${cfg.docLabel} generated successfully.`,
            messageType: "success",
          })
        );
        if (result.data?.pdfUrl) {
          window.open(result.data.pdfUrl, "_blank");
        }
        // Redirect to the list page after the success message shows.
        setTimeout(() => navigate(cfg.listPath), 1200);
      } else {
        alertRef.current.triggerAlert(
          JSON.stringify({
            message:
              result.msg ||
              (isEdit
                ? `Failed to update ${cfg.docLabel}.`
                : `Failed to generate ${cfg.docLabel}.`),
            messageType: "error",
          })
        );
      }
    } catch (error) {
      alertRef.current.triggerAlert(
        JSON.stringify({
          message: error?.message || "Something went wrong.",
          messageType: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  // Opens the edit-impact dialog: computes reserved before/after per product
  // by comparing the originally-loaded items with the edited ones.
  const openSubmitConfirm = async (values) => {
    setEditConfirm({ values, impact: null, impactLoading: true });
    const newItems = (values.items || []).map((it) => ({
      productId: it.productId,
      quantity: it.quantity,
      product_name: productList.find((p) => p.id === it.productId)?.product_name,
    }));
    const impact = await computeReservationImpact({
      storeId: values.store_id,
      // Create has no prior hold; edit diffs against the originally-loaded items.
      oldItems: isEdit ? originalItemsRef.current : [],
      newItems,
    });
    setEditConfirm((prev) =>
      prev ? { ...prev, impact, impactLoading: false } : prev
    );
  };

  const confirmEditSubmit = async () => {
    if (!editConfirm) return;
    setEditSubmitting(true);
    try {
      await submitProforma(editConfirm.values);
    } finally {
      setEditSubmitting(false);
      setEditConfirm(null);
    }
  };

  // Metadata summary shown at the top of the create/update confirmation dialog.
  // Edit mode: load the existing proforma once and prefill the form.
  useEffect(() => {
    if (!isEdit) return;
    (async () => {
      setLoading(true);
      try {
        const result = await apiData("get", `${cfg.baseApi}/${id}`);
        const p = result.data;
        if (result.success && p) {
          // Keep the original items (with names/qty) to diff against on submit.
          originalItemsRef.current = Array.isArray(p.items) ? p.items : [];
          setProformaNumber(p.proforma_number || "");
          setWasCredit(String(p.payment_type) === "1");

          const mappedItems = Array.isArray(p.items)
            ? p.items.map((it) => ({
              productId: it.product_id,
              sellingPrice: it.selling_price,
              quantity: it.quantity,
              subtotal: it.total_price,
              // Round-trip the per-item discount so it shows in the
              // Discount field on reopen instead of looking like it was
              // never applied. discount_amount is a currency (AED) value —
              // it belongs in discountValue, NOT discountPercent (that was
              // a bug: it copied the raw AED number straight into the %
              // box, e.g. a real AED 625 discount reading as "625%").
              // Derive the % properly from amount ÷ gross.
              discountUnit:
                parseFloat(it.discount_amount || 0) > 0 ? "amount" : undefined,
              discountValue:
                parseFloat(it.discount_amount || 0) > 0
                  ? String(parseFloat(it.discount_amount).toFixed(2))
                  : undefined,
              discountPercent: (() => {
                const discAmt = parseFloat(it.discount_amount || 0);
                if (discAmt <= 0) return undefined;
                const gross =
                  parseFloat(it.selling_price || 0) * (parseFloat(it.quantity) || 0);
                return gross > 0 ? ((discAmt / gross) * 100).toFixed(2) : undefined;
              })(),
            }))
            : [];

          formik.setValues({
            ...formik.values,
            orderDate: p.order_date
              ? dayjs(p.order_date).format("YYYY-MM-DD")
              : dayjs().format("YYYY-MM-DD"),
            customer_id: p.customer_id ?? null,
            store_id: p.store_id ?? "",
            salesman_id: p.salesman_id ?? "",
            name: p.customer_name ?? "",
            customer_type: p.customer_type || "Company",
            company_name: p.company_name ?? "",
            billToCompany: p.bill_to_company ?? p.customer_name ?? "",
            creditApprovedBy: p.credit_approved_by ?? "",
            discountPercent: p.discount_percent ?? "",
            countryCode: p.country_code ?? "+971",
            phone_number: p.customer_phone ?? "",
            email: p.customer_email ?? "",
            address: p.address ?? "",
            vat_no: p.vat_no ?? "",
            po_box: p.po_box ?? "",
            emirate: p.emirate ?? "",
            emirateOption: (() => {
              const val = p.emirate ?? "";
              if (!val) return "";
              return isKnownEmirate(val) ? val : "Others";
            })(),
            trn_number: p.trn_number ?? "",
            items: mappedItems.length
              ? mappedItems
              : [{ productId: "", sellingPrice: 0, quantity: 0, subtotal: 0 }],
            // Rows saved before tax_type existed only carry the amounts, so
            // infer the rate from those rather than snapping back to 5%.
            taxType:
              p.tax_type !== undefined &&
                p.tax_type !== null &&
                p.tax_type !== ""
                ? String(p.tax_type)
                : parseFloat(p.subtotal ?? 0) -
                  parseFloat(p.discount_amount ?? 0) >
                  0 && parseFloat(p.tax_amount ?? 0) === 0
                  ? "0"
                  : "5",
            taxAmount: p.tax_amount ?? 0,
            // Both of these drive which recalculation formula runs on any
            // further edit (qty/discount/shipping change) — losing them
            // meant the edit screen silently reset to "exclusive"/"item",
            // and editing an Inclusive-tax or Total-discount CDN/Proforma
            // would recompute the whole summary under the wrong mode,
            // drifting the Grand Total from what was actually issued.
            taxMode: p.tax_mode || "exclusive",
            discountType: p.discount_type || "item",
            shippingCharges: p.shipping_amount ?? 0,
            discount: p.discount_amount ?? 0,
            subtotalSummary: p.subtotal ?? 0,
            grandTotal: p.grand_total ?? 0,
            payment_type: p.payment_type ?? "",
            paymentMethod: p.payment_method ?? "",
            creditDays: p.credit_days ?? "",
            dueDate: p.due_date
              ? dayjs(p.due_date).format("YYYY-MM-DD")
              : dayjs().format("YYYY-MM-DD"),
            notes: p.notes ?? "",
            term_id: p.term_id ?? "",
            terms: p.terms ?? "",
          });
        } else {
          alertRef.current?.triggerAlert(
            JSON.stringify({
              message: result.msg || `Failed to load ${cfg.docLabel}.`,
              messageType: "error",
            })
          );
        }
      } catch (error) {
        console.error("Failed to load proforma:", error);
      } finally {
        setLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (!resubmitId || isEdit) return;
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const res = await apiData("get", `${creditApprovalBaseAPI}/${resubmitId}/resubmit-data`);
        if (cancelled) return;
        if (!res?.success || !res.data?.payload) {
          alertRef.current?.triggerAlert(
            JSON.stringify({
              message: res?.msg || res?.message || "This request can't be re-submitted.",
              messageType: "error",
            })
          );
          setTimeout(() => navigate("/credit-approval/list"), 1500);
          return;
        }
        const pl = res.data.payload;
        formik.setValues((prev) => ({
          ...prev,
          ...pl,
          // Credit stays selected; the user edits days / amounts and sends again.
          payment_type: pl.payment_type ?? 1,
          advances: (Array.isArray(pl.advances) ? pl.advances : []).map((a) => ({
            payment_method: a.payment_method || "",
            amount: a.amount ?? "",
            transaction_id: a.transaction_id || "",
            attachment_url: a.attachment_url || "",
            attachment_name: a.attachment_name || "",
            uploading: false,
          })),
        }));
        setCreditReason(res.data.reason || "");
        setResubmitInfo(res.data);
      } catch (err) {
        console.error("Failed to load the rejected request:", err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resubmitId]);

  const handleSubmitWithValidation = async () => {
    await formik.validateForm();

    const errors = formik.errors;
    if (Object.keys(errors).length > 0) {
      const errorMessages = [];

      const fieldLabels = {
        orderDate: "Order Date",
        name: "Customer Name",
        phone_number: "Mobile Number",
        email: "Email",
        address: "Street Address",
        emirate: "Emirate",
        items: "Products",
        taxAmount: "Tax Amount",
        term_id: "Terms & Conditions",
        payment_type: "Payment Type",
        store_id: "Store",
      };

      Object.keys(errors).forEach((field) => {
        // "items" errors are per-row (one product/bundle line left
        // incomplete — e.g. an extra "Add Bundle"/"Add Product" row that
        // was never filled in) — a blanket "• Products" doesn't say which
        // row or why, so call out the specific row and reason instead.
        if (field === "items") {
          if (typeof errors.items === "string") {
            errorMessages.push(`• Products: ${errors.items}`);
          } else if (Array.isArray(errors.items)) {
            errors.items.forEach((rowErr, idx) => {
              if (!rowErr || typeof rowErr !== "object") return;
              Object.values(rowErr).forEach((msg) => {
                if (msg) errorMessages.push(`• Row ${idx + 1}: ${msg}`);
              });
            });
          }
          return;
        }
        const label = fieldLabels[field] || field.replace(/_/g, " ");
        errorMessages.push(`• ${label}`);
      });

      alertRef.current.triggerAlert(
        JSON.stringify({
          message: `Please fill in the following required fields:\n${errorMessages.join(
            "\n"
          )}`,
          messageType: "warning",
        })
      );
      return;
    }

    formik.handleSubmit();
  };

  const addRow = () => {
    formik.setFieldValue("items", [
      ...formik.values.items,
      { productId: "", sellingPrice: "", quantity: 0, subtotal: "" },
    ]);
    setSearchTerm([...searchTerm, ""]);
  };

  const removeRow = (idx) => {
    const nextItems = [...formik.values.items];
    const nextSearch = [...searchTerm];
    nextItems.splice(idx, 1);
    nextSearch.splice(idx, 1);
    formik.setFieldValue("items", nextItems);
    setSearchTerm(nextSearch);
    recalcSummary(nextItems);
  };

  const recalcSummary = (
    items,
    shippingOverride,
    discountOverride,
    taxTypeOverride,
    bundleDiscountOverride,
    taxModeOverride
  ) => {
    // Bundle rows carry a per-item discount (%) and share the overall
    // bundle discount (%). Both reduce each line's net amount but are
    // NEVER itemised on the printed proforma/invoice — the customer only
    // ever sees the reduced line totals plus the usual Special Discount and
    // VAT. Every discount is a 0-100 percentage (never a currency amount),
    // so a line/bundle can go to 0 but never negative.
    const pricedItems = items.map((row) => {
      const gross =
        (parseFloat(row.sellingPrice) || 0) * (parseFloat(row.quantity) || 0);
      let net = gross;
      if (row.fromBundle) {
        // Per bundle, EITHER one bundle-wide % OR per-item % applies — never
        // both. row.discountMode selects which ("bundle" default | "item").
        if ((row.discountMode || "bundle") === "item") {
          const itemDisc = discountAmountFromPercent(gross, row.discountPercent);
          net = gross - itemDisc;
        } else {
          // Bundle-wide % is applied to the whole bundle's actual price,
          // then spread across its lines in proportion to each line's own
          // share of the bundle — so per-row Subtotal boxes still sum
          // exactly to the discounted bundle total.
          const groupGross = items
            .filter((it) => it.bundleGroupId === row.bundleGroupId)
            .reduce(
              (s, it) =>
                s + (parseFloat(it.sellingPrice) || 0) * (parseFloat(it.quantity) || 0),
              0
            );
          const bundleDiscAmt = discountAmountFromPercent(groupGross, row.bundleDiscount);
          const share = groupGross > 0 ? gross / groupGross : 0;
          net = gross - bundleDiscAmt * share;
        }
      } else {
        // Plain (non-bundle) product row: supports both % and currency amount
        let itemDisc = 0;
        if (row.discountUnit === "amount" || row.discountUnit === "value") {
          itemDisc = parseFloat(row.discountValue || 0);
          if (itemDisc > gross) itemDisc = gross;
        } else {
          itemDisc = discountAmountFromPercent(gross, row.discountPercent);
        }
        net = gross - itemDisc;
      }
      return { ...row, subtotal: Math.max(net, 0).toFixed(2) };
    });

    const subtotal = pricedItems.reduce(
      (sum, row) => sum + (parseFloat(row.subtotal) || 0),
      0
    );

    const discount =
      parseFloat(discountOverride ?? formik.values.discount) || 0;

    const taxRate = parseFloat(taxTypeOverride ?? formik.values.taxType) || 0;
    const taxMode = taxModeOverride ?? formik.values.taxMode ?? "exclusive";

    const shipping =
      parseFloat(shippingOverride ?? formik.values.shippingCharges) || 0;

    // Selling price is always excl. of VAT — tax is always genuinely
    // computed, never ignored. The two modes differ only in WHERE the
    // Special Discount is subtracted:
    //  - Exclusive: discount comes off the pre-tax subtotal, tax is then
    //    added on top of what's left.
    //  - Inclusive: the subtotal shown to the user already has tax folded
    //    in (Subtotal (Incl. of Tax)), so the discount comes off THAT
    //    figure directly — e.g. 105 incl. VAT − 5 discount = 100 — and the
    //    tax amount shown is simply what's embedded in that final number,
    //    extracted for the printed breakdown.
    // What the unit price itself MEANS changes between the two modes — this
    // is the actual difference between them, not just which field you type
    // into:
    //  - Exclusive: the price on each product row is the pre-tax base. Tax
    //    is calculated fresh and added on top at the end. (Unchanged.)
    //  - Inclusive: the price on each product row is treated as ALREADY
    //    containing VAT — e.g. a 45 AED item and a 50 AED item sum to a 95
    //    AED Subtotal that already has tax folded into it. Tax here isn't
    //    added, it's EXTRACTED back out of that 95 to show the breakdown
    //    (Amount before VAT ≈ 90.48, Tax ≈ 4.52), and the Grand Total stays
    //    the sum of what was actually typed on the rows (95 + shipping) —
    //    it does not go up by 5% on top of that.
    let netSubtotal;
    let taxAmount;
    let grandTotal;
    if (taxMode === "inclusive") {
      const discountedSubtotal = Math.max(subtotal - discount, 0);
      // Divide the tax-inclusive figure by (1 + rate/100) to pull the
      // pre-tax base back out — e.g. 105 at 5% VAT means the base was 100,
      // not 105 × 0.95. The OLD code here just re-added tax on top of
      // `subtotal` exactly like the exclusive branch, so picking
      // "Inclusive of Tax" never actually changed how a price was read —
      // only which field looked editable. It's genuinely different now.
      netSubtotal = discountedSubtotal / (1 + taxRate / 100);
      taxAmount = discountedSubtotal - netSubtotal;
      grandTotal = discountedSubtotal + shipping;
    } else {
      const discountedSubtotal = subtotal - discount;
      netSubtotal = discountedSubtotal > 0 ? discountedSubtotal : 0;
      taxAmount = (netSubtotal * taxRate) / 100;
      grandTotal = netSubtotal + taxAmount + shipping;
    }
    // Round to cents — these values feed a directly-editable numeric field
    // (Grand Total, in Inclusive mode) as well as submission payloads, and
    // floating-point division above (e.g. taxAmount = x * rate / (100 +
    // rate)) otherwise leaks values like 411.07500000000005 straight into
    // the UI.
    netSubtotal = parseFloat(netSubtotal.toFixed(2));
    taxAmount = parseFloat(taxAmount.toFixed(2));
    grandTotal = parseFloat(grandTotal.toFixed(2));

    // Functional form — merges onto whatever state is actually pending at
    // apply time, instead of spreading the stale `formik.values` snapshot
    // captured when this closure was created. Callers that do
    // formik.setFieldValue(...) right before calling recalcSummary (e.g.
    // resetting "discount" to 0 on a mode switch) would otherwise have that
    // update silently reverted by this call overwriting it with the old
    // pre-click value.
    formik.setValues((prev) => ({
      ...prev,
      items: pricedItems,
      subtotalSummary: netSubtotal, // excludes shipping
      taxAmount,
      taxMode,
      shippingCharges: shipping, // keep shipping separate
      grandTotal,
    }));
  };

  const handleProductSelect = async (idx, product) => {
    if (!product || !formik.values.store_id) return;

    try {
      const result = await apiData(
        "get",
        `${fetchProductUnitAPI}/${product.id}/${formik.values.store_id}`
      );

      if (result.success) {
        const fetchedSellingPrice = result.data?.[0]?.selling_price
          ? parseFloat(result.data[0].selling_price)
          : 0;

        const fetchedBuyingPrice = result.data?.[0]?.buying_price
          ? parseFloat(result.data[0].buying_price)
          : 0;

        const updatedItems = [...formik.values.items];

        // If user has not typed any price → use fetched selling price
        // Always use the newly selected product's fetched price, so switching a
        // row's product refreshes the price (it previously kept the old price).
        const finalSellingPrice = fetchedSellingPrice;

        updatedItems[idx] = {
          ...updatedItems[idx],
          productId: product.id,
          isBundle: false,
          bundleId: null,
          buyingPrice: fetchedBuyingPrice,
          sellingPrice: finalSellingPrice,
          quantity: updatedItems[idx].quantity || 1,
          subtotal: (
            finalSellingPrice * (updatedItems[idx].quantity || 1)
          ).toFixed(2),
          maxQuantity: product.atp ?? product.quantity,
        };

        formik.setFieldValue("items", updatedItems);
        // Tax % recorded when the stock was added: the first product picked
        // pre-fills the document Tax Rate (still editable). No value saved →
        // the user keeps choosing the rate in the form as before.
        const stockTax = result.data?.[0]?.tax_percent;
        const otherProductPicked = formik.values.items.some(
          (r, i) => i !== idx && r.productId
        );
        if (
          stockTax !== null &&
          stockTax !== undefined &&
          ["0", "5"].includes(String(parseFloat(stockTax))) &&
          !otherProductPicked &&
          String(formik.values.taxType) !== String(parseFloat(stockTax))
        ) {
          const rate = String(parseFloat(stockTax));
          recalcSummary(updatedItems, undefined, undefined, rate, undefined, formik.values.taxMode);
          formik.setFieldValue("taxType", rate);
        } else {
          recalcSummary(updatedItems);
        }
      }
    } catch (error) {
      console.error("Failed to fetch product unit price:", error);
    }
  };

  const handleQuantityChange = (idx, value) => {
    const updatedItems = [...formik.values.items];

    if (value === "") {
      updatedItems[idx].quantity = "";
      updatedItems[idx].subtotal = 0;
      recalcSummary(updatedItems);
      return; // ⛔ skip rest
    }

    if (updatedItems[idx].isBundle) {
      const bundleMax = Number(updatedItems[idx].maxQuantity) || 0;
      let finalValue = parseInt(value, 10) || 0;
      if (bundleMax > 0 && finalValue > bundleMax) {
        finalValue = bundleMax;
        alertRef.current.triggerAlert(
          JSON.stringify({
            message: `Only ${bundleMax} bundle(s) can be made from current stock`,
            messageType: "error",
          })
        );
      }
      updatedItems[idx].quantity = finalValue;
      updatedItems[idx].subtotal =
        (parseFloat(updatedItems[idx].sellingPrice) || 0) * finalValue;
      recalcSummary(updatedItems);
      return;
    }

    const product = productList.find(
      (p) => p.id === updatedItems[idx].productId
    );

    // Cap at Available-to-Promise (physical − reserved), not raw physical stock.
    const atpMax = product?.atp ?? product?.quantity ?? 0;

    // The ATP figure is per-product, not per-row — if the same product is
    // already picked in another row of this document, that quantity has to
    // come out of the pool too, or two rows can each claim the full ATP and
    // together request more stock than actually exists.
    const qtyUsedElsewhere = updatedItems.reduce((sum, row, i) => {
      if (i === idx || row.isBundle || row.productId !== updatedItems[idx].productId) {
        return sum;
      }
      return sum + (parseFloat(row.quantity) || 0);
    }, 0);
    const derivedMax = Math.max(atpMax - qtyUsedElsewhere, 0);

    let finalValue = parseInt(value, 10);
    if (atpMax > 0 && finalValue > derivedMax) {
      // user tried to set more than what's left after other rows' shares
      finalValue = derivedMax;
      const reservedNote =
        product?.reserved > 0 ? ` (${product.reserved} reserved)` : "";
      const elsewhereNote =
        qtyUsedElsewhere > 0 ? `, ${qtyUsedElsewhere} already used in another row` : "";
      alertRef.current.triggerAlert(
        JSON.stringify({
          message: `Only ${derivedMax} available${reservedNote}${elsewhereNote}`,
          messageType: "error",
        })
      );
    }

    updatedItems[idx].quantity = finalValue;
    updatedItems[idx].subtotal =
      (parseFloat(updatedItems[idx].sellingPrice) || 0) * finalValue;

    recalcSummary(updatedItems);
  };

  const fetchProducts = async (search = "") => {
    try {
      const result = await apiData(
        "get",
        `${fetchProductDropdownAPI}?search=${search}`
      );

      if (result.success) {
        setProductList((result.data.result || []).filter((p) => !isBundleProduct(p)));
      }
    } catch (error) {
      console.error("Failed to fetch units:", error);
    }
  };

  const fetchStores = async () => {
    try {
      const result = await apiData("get", storesDropdownAPI);
      if (result.success) {
        setStoreOptions(result.data);
      }
    } catch (error) {
      console.error("Failed to fetch stores:", error);
    }
  };

  const fetchProductsWithStock = async (storeId = null, search = "") => {
    try {
      // Always get all products first
      const allProductsResult = await apiData(
        "get",
        `${fetchProductDropdownAPI}?search=${search}`
      );
      let allProducts = [];
      if (allProductsResult.success) {
        allProducts = (allProductsResult.data.result || [])
          .filter((p) => !isBundleProduct(p))
          .map((p) => ({
            id: p.id,
            product_name: p.product_name,
            sku: p.sku,
            product_image: p.product_image,
            size: p.size,
            color: p.color,
            quantity: 0, // default: out of stock
            inStock: false,
          }));
      }

      if (storeId) {
        // Get stock for this store
        const storeResult = await apiData(
          "get",
          `${fetchProductsByStoreAPI}?id=${storeId}&search=${search}`
        );
        if (storeResult.success) {
          const stockMap = {};
          storeResult.data.forEach((p) => {
            stockMap[p.product_id] = Number(p.quantity) || 0;
          });

          // Merge stock info into all products
          allProducts = allProducts.map((p) => ({
            ...p,
            quantity: stockMap[p.id] || 0,
            inStock: !!stockMap[p.id],
          }));
        }

        // Overlay Available-to-Promise: subtract stock reserved by other
        // proformas so the picker shows/limits what can actually be committed.
        try {
          const availResult = await apiData("post", productAvailabilityAPI, {
            store_id: storeId,
            product_ids: allProducts.map((p) => p.id),
          });
          if (availResult.success && Array.isArray(availResult.data)) {
            const atpMap = {};
            availResult.data.forEach((a) => {
              atpMap[a.product_id] = a;
            });

            // In edit mode, this proforma's OWN current hold must be added back:
            // the endpoint's atp subtracts it, but editing releases + re-reserves
            // it, so this proforma may take up to (available + its own hold).
            const ownHold = {};
            if (isEdit) {
              (originalItemsRef.current || []).forEach((it) => {
                const pid = Number(it.product_id ?? it.productId);
                const q = parseInt(it.quantity || 0, 10);
                if (pid && q > 0) ownHold[pid] = (ownHold[pid] || 0) + q;
              });
            }

            allProducts = allProducts.map((p) => {
              const a = atpMap[p.id];
              if (!a) return { ...p, reserved: 0, atp: p.quantity };
              const own = ownHold[p.id] || 0;
              const atp = a.atp + own; // available to THIS proforma
              const reserved = Math.max(0, a.reserved - own); // held by others
              return {
                ...p,
                quantity: a.onHand, // physical on-hand from live stock
                expired: a.expired || 0, // past expiry: in stock but not sellable
                reserved, // held by OTHER proformas
                atp, // what this proforma can take
                inStock: atp > 0,
              };
            });
          }
        } catch (availErr) {
          console.error("Failed to fetch availability (ATP):", availErr);
        }
      }

      setProductList((prev) => {
        // Map previous state for preserving selected and reference matching
        const prevMap = new Map(prev.map((p) => [p.id, p]));

        return allProducts.map((p) => {
          const old = prevMap.get(p.id);
          return old ? { ...old, ...p } : p;
        });
      });
    } catch (error) {
      console.error("Failed to fetch products:", error);
      setProductList([]);
    }
  };

  const fetchBundles = async (storeId = null, search = "") => {
    try {
      const params = new URLSearchParams();
      if (storeId) params.append("store_id", storeId);
      if (search) params.append("search", search);
      const result = await apiData(
        "get",
        `${fetchBundlesAPI}?${params.toString()}`
      );
      if (result.success) {
        setBundleList(result.data.result || []);
      }
    } catch (error) {
      console.error("Failed to fetch bundles:", error);
      setBundleList([]);
    }
  };

  const handleModeChange = (mode) => {
    if (!mode || mode === selectionMode) return;
    setSelectionMode(mode);
    const emptyRow = { productId: "", sellingPrice: 0, quantity: 0, subtotal: 0 };
    formik.setFieldValue("items", [emptyRow]);
    setSearchTerm([""]);
    // Same reasoning as the Discount Method / Tax Mode / Tax Rate switches —
    // Products <-> Bundle is a fresh start too, so wipe Special Discount
    // instead of recalculating on top of stale values.
    recalcSummary([emptyRow], undefined, 0);
    formik.setFieldValue("discount", 0);
    formik.setFieldValue("discountPercent", "");
  };

  // A bundle carries no price of its own — its value is the sum of its
  // component products' CURRENT selling prices at the selected store.
  const getBundleStorePrice = (bundle) =>
    (bundle?.components || []).reduce(
      (sum, c) =>
        sum + Number(c.selling_price || 0) * Number(c.required_per_bundle || 1),
      0
    );

  const handleBundleSelect = (idx, bundle) => {
    if (!bundle) {
      const updatedItems = [...formik.values.items];
      updatedItems[idx] = {
        ...updatedItems[idx],
        productId: null,
        isBundle: false,
        bundleId: null,
        bundleName: null,
        bundleSku: null,
        sellingPrice: 0,
        quantity: 0,
        subtotal: 0,
        maxQuantity: 0,
      };
      formik.setFieldValue("items", updatedItems);
      recalcSummary(updatedItems);
      return;
    }

    // A bundle is just a group of products: explode it into individual product
    // lines priced at each component's CURRENT selling price (looked up from the
    // store's product list). Any discount is applied afterwards on the invoice
    // (Special / Bundle discount), never on the bundle itself. The form switches
    // to normal product mode so the exploded lines behave like any other rows.
    // Unique id for THIS bundle instance so its discount/grouping is fully
    // independent from every other bundle (even the same bundle added twice).
    const bundleGroupId = `bg-${Date.now()}-${Math.random()
      .toString(36)
      .slice(2, 8)}`;
    const lines = (bundle.components || []).map((c) => {
      const price = Number(c.selling_price || 0);
      const qty = Number(c.required_per_bundle || 1);
      return {
        productId: c.product_id,
        isBundle: false,
        // Came from a bundle — the product itself is locked (can't be swapped),
        // though its price/quantity remain editable.
        bundleId: bundle.id,
        bundleGroupId,
        bundleName: bundle.product_name,
        bundleSku: bundle.sku,
        fromBundle: true,
        // "bundle" = one % for the whole bundle | "item" = per-product %.
        discountMode: "bundle",
        sellingPrice: price,
        quantity: qty,
        subtotal: (price * qty).toFixed(2),
        maxQuantity: Number(c.available || 0),
      };
    });

    // Explode the bundle into product lines in place of the picker row, and stay
    // on the current (Bundle) tab. The exploded rows render as product rows
    // because they now carry a productId (see the row picker condition).
    const updatedItems = [...formik.values.items];
    const updatedSearch = [...searchTerm];
    if (lines.length) {
      updatedItems.splice(idx, 1, ...lines);
      updatedSearch.splice(idx, 1, ...lines.map(() => ""));
    }

    formik.setFieldValue("items", updatedItems);
    setSearchTerm(updatedSearch);
    recalcSummary(updatedItems);
  };

  const getBundleForRow = (row) =>
    bundleList.find((bundle) => bundle.id === row.productId) || null;

  // Refetch stock whenever the selected store changes — the single place
  // this fires from (see the store Autocomplete's onChange above for why a
  // second, duplicate trigger there was removed). productListLoading keeps
  // the product picker disabled until this actually resolves, so
  // openOnFocus can't pop it open showing stale/previous-store stock.
  useEffect(() => {
    if (formik.values.store_id) {
      setProductListLoading(true);
      Promise.all([
        fetchProductsWithStock(formik.values.store_id),
        fetchBundles(formik.values.store_id),
      ]).finally(() => setProductListLoading(false));

      // Only reset items if they don't have productId selected
      const hasSelectedProducts = formik.values.items.some(
        (item) => item.productId
      );
      if (!hasSelectedProducts) {
        // Reset items to initial empty state but keep the structure
        const resetItems = formik.values.items.map((item) => ({
          ...item,
          productId: "",
          sellingPrice: 0,
          quantity: 0,
          subtotal: 0,
          buyingPrice: null,
        }));
        formik.setFieldValue("items", resetItems);
      }
    }
  }, [formik.values.store_id]);

  async function fetchCustomers() {
    const result = await apiData("get", fetchCustomerDDAPI);
    if (result.data?.result) {
      setCustomerList(result.data.result);
    }
  }

  const [termsAndConditions, setTermsAndConditions] = useState([]);
  const fetchTermsAndConditions = async () => {
    try {
      const payload = { termsType: 2 };
      const result = await apiData("get", termsAndConditionsAPI, payload);
      if (result.success) {
        const termsList = result.data.result || [];
        setTermsAndConditions(termsList);

        const defaultTerm = termsList.find((term) => term.isDefault === 1);
        if (defaultTerm) {
          formik.setFieldValue("term_id", defaultTerm.id);
          formik.setFieldValue("terms", defaultTerm.description || "");
        }
      }
    } catch (error) {
      console.error("Failed to fetch terms and conditions:", error);
    }
  };

  useEffect(() => {
    fetchCustomers();
    fetchProducts();
    fetchStores();
    fetchTermsAndConditions();
  }, []);

  const handleCustomerChange = (customer) => {
    const selectedCustId = customer ? customer.customer_id : "";
    formik.setFieldValue("customer_id", selectedCustId);
    formik.setFieldValue("name", customer ? customer.name : "");
    // Existing customer's own Individual/Company classification (set on the
    // Customer Master form) travels with the selection instead of being
    // silently reset — see the "Not in the list?" note in the JSX below.
    formik.setFieldValue(
      "customer_type",
      customer ? customer.customer_type || "Company" : "Company"
    );
    formik.setFieldValue(
      "company_name",
      customer ? customer.company_name || "" : ""
    );
    formik.setFieldValue(
      "billToCompany",
      customer ? customer.company_name || customer.name : ""
    );
    formik.setFieldValue("address", customer ? customer.address : "");
    const customerEmirate = customer ? customer.emirate : "";
    formik.setFieldValue("emirate", customerEmirate);
    formik.setFieldValue(
      "emirateOption",
      customerEmirate
        ? isKnownEmirate(customerEmirate)
          ? customerEmirate
          : "Others"
        : ""
    );
    formik.setFieldValue("email", customer ? customer.email : "");
    formik.setFieldValue("phone_number", customer ? customer.phone_number : "");
    formik.setFieldValue("po_box", customer ? customer.po_box : "");
    formik.setFieldValue("vat_no", customer?.vat_no || "");
    // Fall back to "" (not null/undefined) — Yup's .matches() on trn_number
    // rejects null outright, which would silently block submission with no
    // visible error for any customer that has no TRN on file.
    formik.setFieldValue("trn_number", customer?.trn_number || "");
  };

  let debounceTimer = null;
  const debounce = (fn, delay = 400) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(fn, delay);
  };

  // Advance payments entered on the CDN create form vs the Grand Total:
  //  - advanceCoversTotal: nothing is left to pay, so credit isn't needed and
  //    the CDN is created as Immediate Payment (paid) with no Admin approval.
  //  - advancePartial: credit (if chosen) applies only to the balance.
  const advanceEntered =
    variant === "cdn" && !isEdit
      ? (formik.values.advances || []).reduce(
          (t, a) => t + (parseFloat(a.amount) > 0 ? parseFloat(a.amount) : 0),
          0
        )
      : 0;
  const grandTotalNum = parseFloat(formik.values.grandTotal) || 0;
  const advanceCoversTotal =
    advanceEntered > 0 && grandTotalNum > 0 && advanceEntered >= grandTotalNum - 0.009;
  const advancePartial = advanceEntered > 0 && !advanceCoversTotal;
  const creditBalance = Math.max(0, grandTotalNum - advanceEntered);

  const paymentOptions = useMemo(() => {
    return [
      { value: "1", label: "Cash" },
      { value: "2", label: "Card" },
      { value: "3", label: "Cheque" },
      { value: "5", label: "Bank Transfer" },
      { value: "6", label: "Online Payment" },
      // Bill to Company is no longer offered on CDN/Proforma.
      // { value: "7", label: "Bill to Company" },
    ];
  }, []);

  // The advance covers the whole Grand Total: nothing is left on credit, so
  // switch to Immediate Payment (using the advance's method) and clear the
  // credit fields. Credit stays disabled in the dropdown while this holds.
  useEffect(() => {
    if (advanceCoversTotal && formik.values.payment_type == 1) {
      const firstMethod = (formik.values.advances || []).find(
        (a) => parseFloat(a.amount) > 0 && a.payment_method
      )?.payment_method;
      formik.setFieldValue("payment_type", 2);
      formik.setFieldValue("paymentMethod", firstMethod || "");
      formik.setFieldValue("creditDays", "");
      formik.setFieldValue("dueDate", null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [advanceCoversTotal, formik.values.payment_type]);

  useEffect(() => {
    if (formik.values.payment_type == 2) {
      formik.setFieldValue("creditDays", "");
      formik.setFieldValue("dueDate", null);
    }
  }, [formik.values.payment_type]);

  const handleOrderDateChange = (date) => {
    if (!date) return;

    const formatted = date.format("YYYY-MM-DD");
    formik.setFieldValue("orderDate", formatted);

    if (Number(formik.values.paymentMethod) === 4 && formik.values.creditDays) {
      const newDueDate = dayjs(formatted)
        .add(Number(formik.values.creditDays), "day")
        .format("YYYY-MM-DD");

      formik.setFieldValue("dueDate", newDueDate);
    }
  };

  const hasReservationChange =
    !isEdit ||
    (editConfirm?.impact || []).some(
      (row) =>
        Number(row.oldReserved || 0) !== Number(row.newReserved || 0) ||
        Number(row.availableBefore || 0) !== Number(row.availableAfter || 0)
    );

  const confirmMessage = editConfirm?.impactLoading
    ? isEdit
      ? "Checking whether this edit changes reserved stock..."
      : `Checking stock reservation details before generating this ${cfg.docLabel}...`
    : isEdit
      ? hasReservationChange
        ? "Review the details and how this edit changes reserved stock before saving:"
        : `Review the updated ${cfg.docLabel} details before saving. Reserved stock quantities are unchanged.`
      : `Review the details. Generating this ${cfg.docLabel} will reserve the stock below:`;

  return (
    <Layout>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid className="employee-form">
        <AlertMessage ref={alertRef} />

        <Dialog
          open={Boolean(bundleDetails)}
          onClose={() => setBundleDetails(null)}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle sx={{ pb: 1 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                gap: 2,
                alignItems: "flex-start",
              }}
            >
              <Box>
                <Typography variant="h6">
                  {bundleDetails?.product_name || "Bundle Details"}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  SKU: {bundleDetails?.sku || "-"}
                </Typography>
              </Box>
              <Chip
                size="small"
                color={bundleDetails?.eligible ? "success" : "error"}
                label={
                  bundleDetails?.eligible
                    ? `Available: ${bundleDetails?.max_qty || 0}`
                    : "Out of stock"
                }
              />
            </Box>
          </DialogTitle>
          <DialogContent dividers>
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 2,
                mb: 2,
              }}
            >
              <Typography variant="body2">
                Bundle Price:{" "}
                <b>{formatAED(bundleDetails?.bundle_price || 0)}</b>
              </Typography>
              <Typography variant="body2">
                Components: <b>{bundleDetails?.components?.length || 0}</b>
              </Typography>
            </Box>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Product</TableCell>
                  <TableCell>SKU</TableCell>
                  <TableCell align="right">Qty</TableCell>
                  <TableCell align="right">Stock</TableCell>
                  <TableCell>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(bundleDetails?.components || []).map((component) => {
                  const hasStock =
                    (component.available ?? 0) >=
                    component.required_per_bundle;
                  return (
                    <TableRow key={component.product_id}>
                      <TableCell>{component.product_name}</TableCell>
                      <TableCell>{component.sku || "-"}</TableCell>
                      <TableCell align="right">
                        {component.required_per_bundle}
                      </TableCell>
                      <TableCell align="right">
                        {component.available ?? 0}
                      </TableCell>
                      <TableCell>
                        <Chip
                          size="small"
                          color={hasStock ? "success" : "error"}
                          label={hasStock ? "OK" : "Short"}
                        />
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </DialogContent>
        </Dialog>

        {/* Confirm before creating / saving: a clean summary of the document,
            its totals, how it is paid and the stock it will hold. */}
        {(() => {
          const v = editConfirm?.values;
          const isCredit = !isEdit && String(v?.payment_type) === "1";
          const storeName = storeOptions.find((s) => s.id === v?.store_id)?.store_name || "-";
          const itemCount = (v?.items || []).filter((it) => it.productId).length;
          const methodLabel = (id) => paymentOptions.find((o) => String(o.value) === String(id))?.label || "";
          const advTotal = (v?.advances || []).reduce(
            (t, a) => t + (parseFloat(a.amount) > 0 ? parseFloat(a.amount) : 0),
            0
          );
          const grand = parseFloat(v?.grandTotal) || 0;
          const advMethods = [
            ...new Set(
              (v?.advances || [])
                .filter((a) => parseFloat(a.amount) > 0)
                .map((a) => methodLabel(a.payment_method))
                .filter(Boolean)
            ),
          ].join(", ");
          const payType = isCredit
            ? `Credit${v?.creditDays ? ` · ${v.creditDays} days` : ""}`
            : String(v?.payment_type) === "2"
            ? `Immediate${methodLabel(v?.paymentMethod) ? ` · ${methodLabel(v.paymentMethod)}` : ""}`
            : "-";
          const lbl = { fontSize: 11.5, fontWeight: 700, letterSpacing: 0.4, color: "#64748B", textTransform: "uppercase", mb: 0.75 };
          const card = { border: "1px solid #E3E6EA", borderRadius: "10px", p: 2, bgcolor: "#fff" };
          const field = (k, val) => (
            <Grid item xs={12} sm={6} key={k}>
              <Typography sx={{ fontSize: 12, color: "#64748B" }}>{k}</Typography>
              <Typography sx={{ fontSize: 14, fontWeight: 600, color: "#0F172A", wordBreak: "break-word" }}>
                {val}
              </Typography>
            </Grid>
          );
          const money = (k, val, opts = {}) => (
            <Box sx={{ display: "flex", justifyContent: "space-between", py: 0.35 }}>
              <Typography sx={{ fontSize: 13, color: opts.color || "#64748B", fontWeight: opts.bold ? 700 : 400 }}>{k}</Typography>
              <Typography sx={{ fontSize: opts.big ? 17 : 13, fontWeight: opts.bold ? 700 : 500, color: opts.color || "#0F172A" }}>
                {opts.neg ? "-" : ""}
                {formatAED(val)}
              </Typography>
            </Box>
          );
          return (
            <Dialog
              open={Boolean(editConfirm)}
              onClose={editSubmitting ? undefined : () => setEditConfirm(null)}
              maxWidth="md"
              fullWidth
              PaperProps={{ sx: { borderRadius: "14px", position: "relative", overflow: "hidden" } }}
            >
              {editSubmitting && (
                <Box
                  role="status"
                  aria-live="polite"
                  sx={{
                    position: "absolute",
                    inset: 0,
                    zIndex: 5,
                    bgcolor: "rgba(255,255,255,0.92)",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 1.5,
                    textAlign: "center",
                    px: 4,
                  }}
                >
                  <CircularProgress size={46} thickness={4} />
                  <Typography sx={{ fontWeight: 700, fontSize: 17 }}>
                    {isEdit ? `Saving ${cfg.docLabel}…` : isCredit ? "Sending for Admin approval…" : `Creating ${cfg.docLabel}…`}
                  </Typography>
                  <Typography sx={{ fontSize: 13, color: "#64748B", maxWidth: 380 }}>
                    {isCredit
                      ? "Sending the request to Admin. Please keep this window open."
                      : "Reserving stock, recording any advance and generating the PDF. This can take a few seconds — please keep this window open."}
                  </Typography>
                </Box>
              )}

              <DialogTitle sx={{ pb: 1.5 }}>
                <Typography sx={{ fontWeight: 700, fontSize: 18, lineHeight: 1.2 }}>
                  {isEdit
                    ? `${cfg.confirmTitleEdit}${proformaNumber ? ` — ${proformaNumber}` : ""}`
                    : cfg.confirmTitle}
                </Typography>
                <Typography sx={{ fontSize: 13, color: "#64748B", mt: 0.5, fontWeight: 400 }}>{confirmMessage}</Typography>
              </DialogTitle>

              <DialogContent dividers sx={{ bgcolor: "#F5F6F8" }}>
                {editConfirm?.impactLoading ? (
                  <Box sx={{ textAlign: "center", py: 4 }}>
                    <CircularProgress size={28} />
                  </Box>
                ) : (
                  <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                    {/* what will happen */}
                    {!isEdit && String(v?.payment_type) === "1" && advanceCoversTotal && (
                      <Alert severity="success" sx={{ borderRadius: "10px" }}>
                        <Typography variant="body2" sx={{ fontWeight: 700 }}>
                          The advance covers the full amount — no credit needed.
                        </Typography>
                        <Typography variant="body2">
                          This {cfg.docLabel} will be created now as Immediate Payment (fully paid), without Admin approval.
                        </Typography>
                      </Alert>
                    )}
                    {isCredit && !advanceCoversTotal && (
                      <Alert severity="warning" sx={{ borderRadius: "10px" }}>
                        <Typography variant="body2" sx={{ fontWeight: 700 }}>
                          Credit terms{v?.creditDays ? ` (${v.creditDays} days)` : ""} need Admin approval.
                        </Typography>
                        <Typography variant="body2">
                          This {cfg.docLabel} won't be created yet. It is sent to Admin and becomes a real {cfg.docLabel} once
                          approved.
                          {advancePartial &&
                            ` Credit applies to the balance of ${formatAED(creditBalance)} after the ${formatAED(advanceEntered)} advance.`}
                        </Typography>
                        {creditReason && (
                          <Typography variant="body2" sx={{ mt: 0.5, fontStyle: "italic" }}>
                            Reason given: “{creditReason}”
                          </Typography>
                        )}
                      </Alert>
                    )}

                    <Grid container spacing={2.5} alignItems="flex-start">
                      {/* document */}
                      <Grid item xs={12} md={7}>
                        <Box sx={{ ...card, height: "100%" }}>
                          <Typography sx={lbl}>Document</Typography>
                          <Grid container spacing={1.5}>
                            {field(cfg.docNoLabel, isEdit ? proformaNumber || "-" : "Auto-generated")}
                            {field("Order date", v?.orderDate ? dayjs(v.orderDate).format("DD-MM-YYYY") : "-")}
                            {field("Customer", v?.name || "-")}
                            {field("Store", storeName)}
                            {field("Line items", itemCount)}
                            {field("Payment", payType)}
                            {isCredit && v?.dueDate && field("Due date", dayjs(v.dueDate).format("DD-MM-YYYY"))}
                            {advTotal > 0 && field("Advance paid by", advMethods || "-")}
                          </Grid>
                        </Box>
                      </Grid>

                      {/* totals */}
                      <Grid item xs={12} md={5}>
                        <Box sx={{ ...card, height: "100%" }}>
                          <Typography sx={lbl}>Totals (AED)</Typography>
                          {money("Subtotal", v?.subtotalSummary)}
                          {money("Tax", v?.taxAmount)}
                          {money("Shipping", v?.shippingCharges)}
                          {parseFloat(v?.discount) > 0 && money("Discount", v?.discount, { neg: true })}
                          <Box sx={{ borderTop: "1px solid #E3E6EA", mt: 0.75, pt: 0.75 }}>
                            {money("Grand total", grand, { bold: true, big: true })}
                          </Box>
                          {!isEdit && advTotal > 0 && (
                            <>
                              {money("Advance received", advTotal, { neg: true, color: "#047857" })}
                              {money("Balance due", Math.max(0, grand - advTotal), {
                                bold: true,
                                color: grand - advTotal > 0.009 ? "#B42318" : "#047857",
                              })}
                            </>
                          )}
                        </Box>
                      </Grid>
                    </Grid>

                    {/* stock */}
                    <Box sx={card}>
                      <Typography sx={lbl}>Stock</Typography>
                      {hasReservationChange ? (
                        <ReservationImpactTable rows={editConfirm?.impact} mode={isEdit ? "edit" : "create"} />
                      ) : (
                        <Typography sx={{ color: "#64748B", fontSize: 13.5 }}>
                          Product quantities, reserved stock and available stock stay the same.
                        </Typography>
                      )}
                    </Box>
                  </Box>
                )}
              </DialogContent>

              <DialogActions sx={{ px: 3, py: 2 }}>
                <Button onClick={() => setEditConfirm(null)} disabled={editSubmitting} color="inherit">
                  Cancel
                </Button>
                <LoadingButton
                  onClick={confirmEditSubmit}
                  loading={editSubmitting}
                  disabled={editConfirm?.impactLoading}
                  variant="contained"
                  color={isCredit ? "warning" : "primary"}
                  sx={{ borderRadius: "8px", textTransform: "none", fontWeight: 700, px: 2.5 }}
                >
                  {isEdit
                    ? "Save Changes"
                    : String(editConfirm?.values?.payment_type) === "1"
                    ? "Send for Admin Approval"
                    : cfg.confirmButtonCreate}
                </LoadingButton>
              </DialogActions>
            </Dialog>
          );
        })()}

        {/* Page Title + Breadcrumb */}
        <Grid container spacing={3}>
          <Grid
            textAlign="center"
            item
            className="form-lable"
            xs={12}
            lg={6}
            md={6}
          >
            <Typography className="page_title" textAlign="left">
              {isEdit ? cfg.editPageTitle : cfg.pageTitle}
            </Typography>
            <Breadcrumbs aria-label="breadcrumb">
              <Link underline="hover" color="inherit" href="/dashboard">
                Dashboard
              </Link>
              <Typography color="text.primary">{cfg.pageTitle}</Typography>
            </Breadcrumbs>
          </Grid>

          {/* Actions */}
          <Grid
            textAlign="right"
            item
            className="form-lable"
            xs={12}
            lg={6}
            md={6}
          >
            <LoadingButton
              size="medium"
              variant="outlined"
              color="primary"
              onClick={() => navigate(-1)}
              startIcon={<ArrowBackIosIcon sx={{ fontSize: "14px !important" }} />}
              sx={{ textTransform: "none", fontWeight: 600, borderRadius: "10px" }}
            >
              Back
            </LoadingButton>
          </Grid>
        </Grid>

        {resubmitInfo && (
          <Alert
            severity="warning"
            icon={<InfoOutlinedIcon fontSize="small" />}
            sx={{ mt: 3, borderRadius: 2, alignItems: "flex-start" }}
          >
            <Typography variant="body2" sx={{ fontWeight: 700 }}>
              Re-submitting credit request #{resubmitInfo.request_id}
            </Typography>
            <Typography variant="body2" sx={{ mt: 0.25 }}>
              Rejected{resubmitInfo.rejected_by ? ` by ${resubmitInfo.rejected_by}` : ""}
              {resubmitInfo.rejected_at ? ` on ${dayjs(resubmitInfo.rejected_at).format("DD-MM-YYYY")}` : ""}
              {resubmitInfo.rejection_note ? ` — “${resubmitInfo.rejection_note}”` : "."}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              Adjust the credit days, advance or payment type below, then submit. It is sent as a new request
              linked to #{resubmitInfo.request_id}, so Admin sees the earlier decision.
            </Typography>
          </Alert>
        )}

        <form onSubmit={formik.handleSubmit}>
          <Box
            sx={{
              mt: 3,
              backgroundColor: "#F5F6F8",
              p: { xs: 1.5, sm: 2.5 },
              borderRadius: 3,
              // One consistent look for every field on the form.
              "& .MuiOutlinedInput-root": {
                borderRadius: "10px",
                backgroundColor: "#fff",
                fontSize: 14,
                "& .MuiOutlinedInput-notchedOutline": { borderColor: "#D9DEE5" },
                "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#B6C0CE" },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: "#0c54a0", borderWidth: "1.5px" },
                "&.Mui-disabled": { backgroundColor: "#F3F5F8" },
              },
              "& .MuiInputLabel-root": { fontSize: 14 },
              "& .MuiFormHelperText-root": { marginLeft: "2px", fontSize: 11.5 },
            }}
          >
            {/* Order Details */}
            <Box
              sx={{
                border: "1px solid #E3E6EA",
                borderRadius: "14px",
                p: { xs: 2, sm: 3.5 },
                mb: 3,
                backgroundColor: "#fff",
                boxShadow: "0 1px 2px rgba(16,24,40,0.04)",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1.25,
                  mb: 2.5,
                }}
              >
                <Box
                  sx={{
                    width: 26,
                    height: 26,
                    borderRadius: "7px",
                    bgcolor: "#EEF2FF",
                    color: "#2F5FED",
                    fontSize: 12,
                    fontWeight: 700,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  1
                </Box>
                <Typography sx={{ fontWeight: 700, fontSize: 15 }}>
                  {cfg.sectionTitle}
                </Typography>
              </Box>

              <Grid container spacing={2.5} alignItems="flex-start">
                <Grid item xs={12} md={6} lg={4}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <MobileDatePicker
                      label="Order Date"
                      value={
                        formik.values.orderDate
                          ? dayjs(formik.values.orderDate)
                          : null
                      }
                      inputFormat="DD-MM-YYYY"
                      onChange={(date) => handleOrderDateChange(date)}
                      onClose={() => formik.setFieldTouched("orderDate", true)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          onBlur={() => formik.setFieldTouched("orderDate", true)}
                          error={
                            formik.touched.orderDate &&
                            Boolean(formik.errors.orderDate)
                          }
                          helperText={
                            formik.touched.orderDate && formik.errors.orderDate
                          }
                        />
                      )}
                    />
                  </LocalizationProvider>
                </Grid>

                <Grid item xs={12} lg={4} md={6} sx={{ minWidth: 0 }}>
                  <Autocomplete
                    sx={{
                      minWidth: 0,
                      "& .MuiInputBase-root": { minWidth: 0 },
                      "& .MuiInputBase-input": {
                        minWidth: 0,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      },
                    }}
                    options={customerList}
                    getOptionLabel={(option) =>
                      option
                        ? `${option.company_name ? `${option.company_name} (${option.name})` : option.name}${option.phone_number ? ` - ${option.phone_number}` : ""}`
                        : ""
                    }
                    value={
                      customerList?.find(
                        (c) => c.customer_id == formik.values.customer_id
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      handleCustomerChange(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Customer"
                        variant="outlined"
                        error={
                          formik.touched.customer_id &&
                          Boolean(formik.errors.customer_id)
                        }
                        helperText={
                          (formik.touched.customer_id && formik.errors.customer_id) ||
                          "Not in the list? Leave this empty and type their details below — a new customer will be created automatically."
                        }
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  {/* Only meaningful for a NEW customer typed below (no
                    customer_id) — an existing customer's type is fixed on
                    Customer Master and is only re-shown here for visibility
                    when picked from the dropdown above (handleCustomerChange
                    populates it). See [[Customers.jsx]] for the master form
                    this mirrors. Built as a fixed-height bordered box with a
                    floating label (matching the TextField/Autocomplete boxes
                    either side of it) instead of a caption-over-control stack
                    — a caption line above the control adds height the
                    sibling fields don't have, so the row stops lining up. */}
                  <Box
                    sx={{
                      position: "relative",
                      height: 56,
                      border: "1px solid",
                      borderColor: "#D9DEE5",
                      borderRadius: "10px",
                      backgroundColor: "#fff",
                      display: "flex",
                      alignItems: "center",
                      px: 0.75,
                    }}
                  >
                    <Typography
                      sx={{
                        position: "absolute",
                        top: -9,
                        left: 10,
                        px: 0.5,
                        fontSize: 12,
                        bgcolor: "background.paper",
                        color: "text.secondary",
                      }}
                    >
                      Customer Type *
                    </Typography>
                    <ToggleButtonGroup
                      exclusive
                      fullWidth
                      color="primary"
                      value={formik.values.customer_type}
                      onChange={(event, type) => {
                        if (!type) return;
                        formik.setFieldValue("customer_type", type);
                        if (type === "Individual") {
                          formik.setFieldValue("company_name", "");
                        }
                      }}
                      sx={{ height: 40 }}
                    >
                      <ToggleButton value="Company" sx={{ flex: 1 }}>Company</ToggleButton>
                      <ToggleButton value="Individual" sx={{ flex: 1 }}>Individual</ToggleButton>
                    </ToggleButtonGroup>
                  </Box>
                </Grid>
                {formik.values.customer_type === "Company" && (
                  <Grid item xs={12} md={6} lg={4}>
                    <TextField
                      fullWidth
                      name="company_name"
                      label="Company Name *"
                      placeholder="Enter registered company name"
                      value={formik.values.company_name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={formik.touched.company_name && Boolean(formik.errors.company_name)}
                      helperText={formik.touched.company_name && formik.errors.company_name}
                    />
                  </Grid>
                )}
                <Grid item xs={12} md={6} lg={4} sx={{ minWidth: 0 }}>
                  {/* Without minWidth:0 a flex/grid item defaults to
                    shrink-to-fit (minWidth:auto) — a long value here (e.g. a
                    customer name used as the Bill To fallback) then ignores
                    the column's allotted width and overflows into/over the
                    "Select Customer" field to its left instead of
                    truncating. Same fix applied to that Autocomplete above. */}
                  <TextField
                    fullWidth
                    label="Bill To Company"
                    InputLabelProps={{ shrink: true }}
                    name="billToCompany"
                    value={formik.values.billToCompany}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    placeholder="Company / Bill To Name"
                    sx={{
                      minWidth: 0,
                      "& .MuiInputBase-root": { minWidth: 0 },
                      "& .MuiInputBase-input": {
                        minWidth: 0,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  {/* "name" is the same tbl_customers column Customer Master
                    writes to, where it means "Contact Person Name" for a
                    Company and "Customer Name" for an Individual (see
                    [[Customers.jsx]]). Label must switch the same way here —
                    otherwise a Company created from this form stores its
                    contact person under a field labeled "Customer Name",
                    which doesn't match how Customer Master itself presents
                    (or lets someone re-edit) that same record. */}
                  <TextField
                    fullWidth
                    label={
                      formik.values.customer_type === "Company"
                        ? "Contact Person Name *"
                        : "Customer Name *"
                    }
                    name="name"
                    value={formik.values.name}
                    onChange={(e) => {
                      let value = e.target.value;
                      formik.setFieldValue("name", value);
                      if (!formik.values.billToCompany) {
                        formik.setFieldValue("billToCompany", value);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    error={formik.touched.name && Boolean(formik.errors.name)}
                    helperText={formik.touched.name && formik.errors.name}
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <Autocomplete
                      options={countryCodes}
                      getOptionLabel={(option) =>
                        typeof option === "string"
                          ? option
                          : option?.label || option?.code || ""
                      }
                      isOptionEqualToValue={(option, val) =>
                        option.code === (typeof val === "string" ? val : val?.code)
                      }
                      value={
                        countryCodes.find(
                          (c) => c.code === (formik.values.countryCode || "+971")
                        ) || {
                          code: formik.values.countryCode || "+971",
                          label: `${formik.values.countryCode || "+971"}`,
                        }
                      }
                      onChange={(event, newValue) => {
                        const selectedCode =
                          typeof newValue === "string"
                            ? newValue
                            : newValue?.code || "+971";
                        formik.setFieldValue("countryCode", selectedCode);
                      }}
                      disableClearable
                      sx={{ width: 175, flexShrink: 0 }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Code"
                          variant="outlined"
                        />
                      )}
                    />
                    <TextField
                      fullWidth
                      label="Customer Mobile"
                      name="phone_number"
                      value={formik.values.phone_number}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.phone_number &&
                        Boolean(formik.errors.phone_number)
                      }
                      helperText={
                        formik.touched.phone_number && formik.errors.phone_number
                      }
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  <TextField
                    fullWidth
                    label="Customer Email"
                    name="email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.email && Boolean(formik.errors.email)}
                    helperText={formik.touched.email && formik.errors.email}
                  />
                </Grid>

                <Grid item xs={12} md={6} lg={6}>
                  <TextField
                    fullWidth
                    label="Street Address"
                    name="address"
                    value={formik.values.address}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.address && Boolean(formik.errors.address)
                    }
                    helperText={formik.touched.address && formik.errors.address}
                  />
                </Grid>

                <Grid item xs={12} md={6} lg={3}>
                  <TextField
                    name="emirateOption"
                    select
                    label="Select Emirate"
                    fullWidth
                    value={formik.values.emirateOption}
                    onChange={(e) => {
                      const value = e.target.value;
                      formik.setFieldValue("emirateOption", value);
                      formik.setFieldValue(
                        "emirate",
                        value === "Others" ? "" : value
                      );
                    }}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.emirate && Boolean(formik.errors.emirate)
                    }
                    helperText={formik.touched.emirate && formik.errors.emirate}
                  >
                    {emirates.map((emirate) => (
                      <MenuItem key={emirate.id} value={emirate.name}>
                        {emirate.name}
                      </MenuItem>
                    ))}
                    <MenuItem value="Others">Others</MenuItem>
                  </TextField>
                </Grid>

                {formik.values.emirateOption === "Others" && (
                  <Grid item xs={12} md={6} lg={3}>
                    <TextField
                      fullWidth
                      name="emirate"
                      label="Please specify Emirate/City/Country"
                      placeholder="Enter emirate, city or country"
                      value={formik.values.emirate}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.emirate && Boolean(formik.errors.emirate)
                      }
                      helperText={
                        formik.touched.emirate && formik.errors.emirate
                      }
                    />
                  </Grid>
                )}

                <Grid item xs={12} md={6} lg={3}>
                  <TextField
                    fullWidth
                    label="P.O.Box"
                    name="po_box"
                    value={formik.values.po_box}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.po_box && Boolean(formik.errors.po_box)}
                    helperText={formik.touched.po_box && formik.errors.po_box}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="VAT No."
                    name="vat_no"
                    value={formik.values.vat_no}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched.vat_no &&
                      Boolean(formik.errors.vat_no)
                    }
                    helperText={
                      formik.touched.vat_no && formik.errors.vat_no
                    }
                  />
                </Grid>

                <Grid item xs={12} lg={6} md={6}>
                  <Autocomplete
                    // Only stock-holding stores (type "store" or "warehouse") can
                    // be the source of this document; salesman-type stores are excluded.
                    // store_type is a tbl_status id, so match on the joined name.
                    options={storeOptions.filter((s) => {
                      const t = (s.store_type_name || "").toLowerCase();
                      return t.includes("store") || t.includes("warehouse");
                    })}
                    getOptionLabel={(option) => option.store_name || ""}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    value={
                      storeOptions.find((s) => s.id === formik.values.store_id) ||
                      null
                    }
                    onChange={(e, newValue) => {
                      formik.setFieldValue(
                        "store_id",
                        newValue ? newValue.id : ""
                      );
                      // Fetching is left to the store_id effect below (single
                      // source of truth) — calling fetchProductsWithStock here
                      // too used to fire a second, redundant request racing
                      // the effect's one; whichever landed last "won", which
                      // is exactly what made the product picker occasionally
                      // pop open (openOnFocus) with the wrong/previous store's
                      // stock the first time, only correcting itself once
                      // closed and reopened after both had settled.
                      const resetItems = formik.values.items.map((item) => ({
                        ...item,
                        productId: "",
                        isBundle: false,
                        bundleId: null,
                        sellingPrice: "",
                        quantity: 0,
                        subtotal: 0,
                        maxQuantity: 0,
                      }));
                      formik.setFieldValue("items", resetItems);
                    }}
                    renderOption={(props, option) => (
                      <li
                        {...props}
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        {option.store_name}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select a Store"
                        fullWidth
                        error={
                          formik.touched.store_id &&
                          Boolean(formik.errors.store_id)
                        }
                        helperText={
                          formik.touched.store_id && formik.errors.store_id
                        }
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: <>{params.InputProps.endAdornment}</>,
                        }}
                      />
                    )}
                    ListboxProps={{
                      style: { maxHeight: 200, overflowY: "auto" },
                    }}
                  />
                </Grid>

                {/* Optional salesman = a store whose type name contains "sales"
                  (e.g. "sales Person"). store_type is a tbl_status id, so we
                  match on the joined type name rather than a hardcoded id. */}
                <Grid item xs={12} lg={6} md={6}>
                  <Autocomplete
                    options={storeOptions.filter((s) =>
                      (s.store_type_name || "").toLowerCase().includes("sales")
                    )}
                    getOptionLabel={(option) => option.store_name || ""}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    value={
                      storeOptions.find(
                        (s) => s.id === formik.values.salesman_id
                      ) || null
                    }
                    onChange={(e, newValue) =>
                      formik.setFieldValue(
                        "salesman_id",
                        newValue ? newValue.id : ""
                      )
                    }
                    renderInput={(params) => (
                      <TextField {...params} label="Salesman (optional)" fullWidth />
                    )}
                    ListboxProps={{
                      style: { maxHeight: 200, overflowY: "auto" },
                    }}
                  />
                </Grid>
              </Grid>

            </Box>

            {/* Product Selection */}
            <Box
              sx={{
                border: "1px solid #E3E6EA",
                borderRadius: "14px",
                p: { xs: 2, sm: 3.5 },
                mb: 3,
                backgroundColor: "#fff",
                boxShadow: "0 1px 2px rgba(16,24,40,0.04)",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  gap: 1.5,
                  mb: 1.5,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
                  <Box
                    sx={{
                      width: 26,
                      height: 26,
                      borderRadius: "7px",
                      bgcolor: "#EEF2FF",
                      color: "#2F5FED",
                      fontSize: 12,
                      fontWeight: 700,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    2
                  </Box>
                  <Typography sx={{ fontWeight: 700, fontSize: 15 }}>
                    Product Selection
                  </Typography>
                </Box>
                <PillToggle
                  value={selectionMode}
                  onChange={handleModeChange}
                  options={[
                    { value: "product", label: "Products" },
                    { value: "bundle", label: "Bundle" },
                  ]}
                />
              </Box>

              {/* Discount Method / Tax Mode / Tax Rate — set these FIRST,
                  before entering line items, since they change how the entry
                  form behaves: Discount Method decides whether each row gets
                  its own discount box or a single total discount applies, and
                  Tax Mode decides whether "Incl. of Tax" figures show
                  alongside every price as you type. Moved up from the Summary
                  card so they're picked before, not after, filling in items. */}
              {/* Compact segmented controls instead of three long dropdowns —
                  each of these is only ever a 2-way choice, so a pill toggle
                  (same component as the Products/Bundle switch above) reads
                  faster and takes a fraction of the width a <Select> needs. */}
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: {
                    xs: "1fr",
                    sm: "repeat(2, minmax(0, 1fr))",
                    lg: "repeat(3, minmax(0, 1fr))",
                  },
                  alignItems: "start",
                  gap: 2.25,
                  p: 2,
                  mb: 2,
                  borderRadius: "12px",
                  backgroundColor: "#F8FAFC",
                  border: "1px solid #EEF2F7",
                  // Small caps labels above each control.
                  "& > div > .MuiTypography-caption": {
                    textTransform: "uppercase",
                    letterSpacing: "0.06em",
                    fontSize: "0.64rem",
                    fontWeight: 700,
                    color: "#94A3B8",
                    mb: "8px",
                  },
                }}
              >
                {selectionMode === "product" && (
                  <Box>
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      sx={{ display: "block", mb: 0.5, fontWeight: 500 }}
                    >
                      Discount Method
                    </Typography>
                    <PillToggle soft
                      value={formik.values.discountType}
                      onChange={(mode) => {
                        // Convert the discount representation instead of
                        // wiping it — Grand Total must stay exactly the
                        // same across the switch. Critical on the edit
                        // page: this toggle must never blank out already-
                        // saved discount data just because it's being
                        // looked at differently.
                        const items = formik.values.items;
                        let updatedItems = items;
                        let newDocDiscount = formik.values.discount;
                        let newDocDiscountPercent = formik.values.discountPercent;

                        if (mode === "total") {
                          // Item-wise -> Total: fold every item's own
                          // discount into one Special Discount figure,
                          // then clear the item-level boxes.
                          const grossSubtotal = items.reduce((s, r) => {
                            if (r.fromBundle) return s;
                            return (
                              s +
                              (parseFloat(r.sellingPrice) || 0) *
                                (parseFloat(r.quantity) || 0)
                            );
                          }, 0);
                          const netSubtotal = items.reduce((s, r) => {
                            if (r.fromBundle) return s;
                            return s + (parseFloat(r.subtotal) || 0);
                          }, 0);
                          const totalItemDiscount = Math.max(
                            grossSubtotal - netSubtotal,
                            0
                          );
                          newDocDiscount = totalItemDiscount.toFixed(2);
                          newDocDiscountPercent =
                            grossSubtotal > 0
                              ? (
                                  (totalItemDiscount / grossSubtotal) *
                                  100
                                ).toFixed(2)
                              : "";
                          updatedItems = items.map((it) =>
                            it.fromBundle
                              ? it
                              : { ...it, discountValue: "", discountPercent: "" }
                          );
                        } else {
                          // Total -> Item-wise: spread the current Special
                          // Discount across items proportional to each
                          // line's own price × qty share.
                          const rawGrossTotal = items.reduce((s, r) => {
                            if (r.fromBundle) return s;
                            return (
                              s +
                              (parseFloat(r.sellingPrice) || 0) *
                                (parseFloat(r.quantity) || 0)
                            );
                          }, 0);
                          const docDiscount =
                            parseFloat(formik.values.discount) || 0;
                          updatedItems = items.map((r) => {
                            if (r.fromBundle || !r.productId) return r;
                            const gross =
                              (parseFloat(r.sellingPrice) || 0) *
                              (parseFloat(r.quantity) || 0);
                            const share =
                              rawGrossTotal > 0 ? gross / rawGrossTotal : 0;
                            const itemDiscount = docDiscount * share;
                            const pct =
                              gross > 0
                                ? ((itemDiscount / gross) * 100).toFixed(2)
                                : "";
                            return {
                              ...r,
                              discountUnit: "amount",
                              discountValue: itemDiscount.toFixed(2),
                              discountPercent: pct,
                            };
                          });
                          newDocDiscount = 0;
                          newDocDiscountPercent = "";
                        }

                        // recalcSummary's own setValues call replaces the
                        // whole values object wholesale, so any
                        // setFieldValue(...) issued BEFORE it here gets
                        // silently reverted (Formik resolves recalcSummary's
                        // update against its own stale pre-call snapshot).
                        // Issuing these AFTER instead makes them win.
                        recalcSummary(
                          updatedItems,
                          formik.values.shippingCharges,
                          newDocDiscount
                        );
                        formik.setFieldValue("discount", newDocDiscount);
                        formik.setFieldValue(
                          "discountPercent",
                          newDocDiscountPercent
                        );
                        formik.setFieldValue("discountType", mode);
                      }}
                      options={[
                        { value: "item", label: "Item-wise" },
                        { value: "total", label: "Total" },
                      ]}
                    />
                  </Box>
                )}
                {/* Tax — Mode and Rate grouped together under one label,
                    since Rate is a sub-setting of Tax, not a peer of
                    Discount Method. */}
                <Box>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 0.4,
                      mb: 0.5,
                      fontWeight: 500,
                    }}
                  >
                    Tax Mode
                    {/* Explains what the mode actually DOES to the unit
                        prices below — on hover/tap only, so it doesn't cost
                        permanent space the way a persistent banner did. */}
                    <Tooltip
                      arrow
                      title={
                        (formik.values.taxMode || "exclusive") === "exclusive"
                          ? "Each product's Unit Price below is before VAT. Tax gets added on top when totaling up, so the Grand Total ends up higher than the prices you entered."
                          : "Each product's Unit Price below is treated as already including VAT. Tax is worked back out of it for the Subtotal/Tax breakdown, but the Grand Total stays the same as what the prices add up to."
                      }
                    >
                      <InfoOutlinedIcon
                        sx={{ fontSize: 14, color: "text.disabled", cursor: "help" }}
                      />
                    </Tooltip>
                  </Typography>
                  <PillToggle soft
                    value={formik.values.taxMode || "exclusive"}
                    onChange={(mode) => {
                      // Preserve whatever's already there — just read the
                      // SAME unit prices under the new mode's math. Critical
                      // on the edit page: switching modes must never blank
                      // out already-saved discount data. Exclusive reads
                      // each row's price as pre-tax (tax added on top);
                      // Inclusive reads it as already containing tax (tax
                      // extracted back out) — see recalcSummary's own
                      // branch for the actual math.
                      recalcSummary(
                        formik.values.items,
                        undefined,
                        formik.values.discount,
                        formik.values.taxType,
                        undefined,
                        mode
                      );
                      formik.setFieldValue("taxMode", mode);
                    }}
                    options={[
                      { value: "exclusive", label: "Exclusive of Tax" },
                      { value: "inclusive", label: "Inclusive of Tax" },
                    ]}
                  />
                </Box>
                <Box>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ display: "block", mb: 0.5, fontWeight: 500 }}
                  >
                    Tax Rate
                  </Typography>
                  <PillToggle soft
                    value={String(formik.values.taxType)}
                    onChange={(rate) => {
                      // Same reasoning as Discount Method / Tax Mode above —
                      // changing the tax rate shifts every downstream figure
                      // (discount %, Subtotal after Discount), so wipe them
                      // back to a clean slate rather than recompute on top
                      // of a now-stale discount.
                      const clearedItems = formik.values.items.map((row) =>
                        row.fromBundle
                          ? row
                          : { ...row, discountValue: "", discountPercent: "" }
                      );
                      recalcSummary(
                        clearedItems,
                        undefined,
                        0,
                        rate,
                        undefined,
                        formik.values.taxMode
                      );
                      formik.setFieldValue("discount", 0);
                      formik.setFieldValue("discountPercent", "");
                      formik.setFieldValue("taxType", rate);
                    }}
                    options={[
                      { value: "5", label: "5%" },
                      { value: "0", label: "0%" },
                    ]}
                  />
                </Box>
              </Box>

              {/* Table Header */}
              <Grid
                container
                spacing={1}
                sx={{
                  backgroundColor: "#F8FAFC",
                  border: "1px solid #EEF2F7",
                  borderRadius: "10px",
                  mt: 1,
                  mb: 1,
                  py: 0.5,
                  ml: 0,
                  width: "100%",
                  "& .MuiTypography-root": {
                    lineHeight: 1.35,
                    textTransform: "uppercase",
                    letterSpacing: "0.05em",
                    fontSize: "0.64rem",
                    fontWeight: 700,
                    color: "#64748B",
                  },
                  display: {
                    xs: "none",
                    // Bundle mode never uses these generic columns — the
                    // picker is a single full-width field, and a selected
                    // bundle renders as its own card with its own labels — so
                    // hide this header for the whole mode, not just once a
                    // bundle has actually been picked.
                    md:
                      selectionMode === "bundle" ||
                        formik.values.items.some((r) => r.fromBundle)
                        ? "none"
                        : "flex",
                  },
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Grid item md={2.5}>
                  <Typography variant="caption" fontWeight={600}>
                    Product Name / SKU
                  </Typography>
                </Grid>
                <Grid item md={1.5}>
                  <Typography variant="caption" fontWeight={600}>
                    Unit Price
                    <Box component="span" sx={{ display: "block", fontWeight: 500, opacity: 0.8 }}>
                      {formik.values.taxMode === "inclusive" ? "(Incl. VAT)" : "(Excl. VAT)"}
                    </Box>
                  </Typography>
                </Grid>
                <Grid item md={1.2}>
                  <Typography variant="caption" fontWeight={600}>
                    Quantity
                  </Typography>
                </Grid>
                <Grid item md={1.6}>
                  <Typography variant="caption" fontWeight={600}>
                    Subtotal
                  </Typography>
                </Grid>
                <Grid item md={2.6}>
                  <Typography variant="caption" fontWeight={600}>
                    Discount (Amount or %)
                  </Typography>
                </Grid>
                <Grid item md={1.6}>
                  <Typography variant="caption" fontWeight={600}>
                    After Discount
                  </Typography>
                </Grid>
                <Grid item md={1} />
              </Grid>

              {/* Dynamic Items */}
              {formik.values.items.map((row, idx) => {
                const previousRow = formik.values.items[idx - 1];
                const nextRow = formik.values.items[idx + 1];
                const showBundleHeader =
                  row.fromBundle &&
                  (!previousRow?.fromBundle ||
                    previousRow.bundleGroupId !== row.bundleGroupId);
                const isLastBundleRow =
                  row.fromBundle &&
                  (!nextRow?.fromBundle ||
                    nextRow.bundleGroupId !== row.bundleGroupId);

                return (
                  <Fragment key={idx}>
                    {showBundleHeader && (
                      <Grid item xs={12} sx={{ mt: 2 }}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: 1.5,
                            px: 1.5,
                            py: 1,
                            border: "1px solid #B8D7FF",
                            borderBottom: "none",
                            borderRadius: "8px 8px 0 0",
                            backgroundColor: "#EEF4FF",
                          }}
                        >
                          <Box sx={{ minWidth: 0, display: "flex", flexDirection: "column", gap: 0.25 }}>
                            <Typography
                              variant="body2"
                              fontWeight={700}
                              color="#0c54a0"
                              noWrap
                            >
                              Bundle: {row.bundleName || "Selected Bundle"}
                            </Typography>
                            {row.bundleSku ? (
                              <Typography
                                variant="caption"
                                sx={{ color: "text.secondary" }}
                                noWrap
                              >
                                SKU: {row.bundleSku} • {formik.values.items.filter(i => i.bundleGroupId === row.bundleGroupId).length} items
                              </Typography>
                            ) : null}
                          </Box>

                          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                            {(() => {
                              const grp = formik.values.items.filter(
                                (it) => it.bundleGroupId === row.bundleGroupId
                              );
                              const groupGross = grp.reduce(
                                (s, it) => s + (parseFloat(it.sellingPrice || 0) * (parseFloat(it.quantity || 0) || 0)),
                                0
                              );
                              const mode = row.discountMode || "bundle";
                              const groupNet =
                                mode === "item"
                                  ? grp.reduce((s, it) => {
                                    const gross =
                                      parseFloat(it.sellingPrice || 0) *
                                      (parseFloat(it.quantity || 0) || 0);
                                    const itDisc = discountAmountFromPercent(
                                      gross,
                                      it.discountPercent
                                    );
                                    return s + (gross - itDisc);
                                  }, 0)
                                  : Math.max(
                                    groupGross -
                                    discountAmountFromPercent(groupGross, row.bundleDiscount),
                                    0
                                  );
                              const discAmt = groupGross - groupNet;

                              return (
                                <Box sx={{ textAlign: "right", minWidth: 200 }}>
                                  <Box sx={{ fontSize: 12, color: "text.secondary" }}>
                                    Subtotal: {formatAED(groupGross)}
                                  </Box>
                                  <Box sx={{ fontSize: 12, color: "text.secondary" }}>
                                    - Discount: {formatAED(discAmt)}
                                  </Box>
                                  <Box sx={{ fontSize: 14, fontWeight: 700, color: "#0c54a0" }}>
                                    Total: {formatAED(groupNet)}
                                  </Box>
                                </Box>
                              );
                            })()}

                            <TextField
                              select
                              size="small"
                              label="Discount type"
                              value={row.discountMode || "bundle"}
                              onChange={(e) => {
                                const modeVal = e.target.value;
                                const updatedItems = formik.values.items.map(
                                  (item) =>
                                    item.bundleGroupId === row.bundleGroupId
                                      ? { ...item, discountMode: modeVal }
                                      : item
                                );
                                formik.setFieldValue("items", updatedItems);
                                recalcSummary(updatedItems);
                              }}
                              sx={{ width: 200 }}
                            >
                              <MenuItem value="bundle">Bundle Discount %</MenuItem>
                              <MenuItem value="item">Per Item Discount %</MenuItem>
                            </TextField>

                            {(row.discountMode || "bundle") === "bundle" && (
                              <TextField
                                size="small"
                                label="Bundle Discount %"
                                value={row.bundleDiscount ?? ""}
                                onFocus={(e) => e.target.select()}
                                onChange={(e) => {
                                  const value = sanitizePercentInput(e.target.value);
                                  const updatedItems = formik.values.items.map((item) =>
                                    item.bundleGroupId === row.bundleGroupId
                                      ? { ...item, bundleDiscount: value }
                                      : item
                                  );
                                  formik.setFieldValue("items", updatedItems);
                                  recalcSummary(updatedItems);
                                }}
                                InputProps={{
                                  endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                }}
                                inputProps={{ inputMode: "decimal", max: 100, min: 0 }}
                                sx={{ width: 160 }}
                              />
                            )}

                            <Tooltip title="Remove this bundle" arrow>
                              <IconButton
                                size="small"
                                sx={{ color: "#c62828", flexShrink: 0 }}
                                onClick={() => {
                                  const items = formik.values.items;
                                  const key = (it) =>
                                    it?.bundleGroupId ?? `bid-${it?.bundleId}`;
                                  const groupKey = key(row);
                                  // idx is this bundle's header (first) row — remove
                                  // only its contiguous rows, not every bundle.
                                  let end = idx;
                                  while (
                                    end + 1 < items.length &&
                                    items[end + 1].fromBundle &&
                                    key(items[end + 1]) === groupKey
                                  ) {
                                    end++;
                                  }
                                  const kept = [];
                                  const keptSearch = [];
                                  items.forEach((it, i) => {
                                    if (i < idx || i > end) {
                                      kept.push(it);
                                      keptSearch.push(searchTerm[i] ?? "");
                                    }
                                  });
                                  const finalItems = kept.length
                                    ? kept
                                    : [
                                      {
                                        productId: "",
                                        sellingPrice: 0,
                                        quantity: 0,
                                        subtotal: 0,
                                      },
                                    ];
                                  formik.setFieldValue("items", finalItems);
                                  setSearchTerm(kept.length ? keptSearch : [""]);
                                  recalcSummary(finalItems);
                                }}
                              >
                                <DeleteOutlineOutlinedIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        </Box>
                        <Box
                          sx={{
                            borderLeft: "1px solid #B8D7FF",
                            borderRight: "1px solid #B8D7FF",
                            backgroundColor: "#fff",
                            px: 1.5,
                            py: 0.5,
                          }}
                        >
                          <Typography
                            variant="caption"
                            sx={{ color: "text.secondary", fontStyle: "italic" }}
                          >
                            🔒 Discounts are for internal records only — they are not
                            shown on the printed proforma / CDN; the customer
                            only sees the reduced prices.
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: { xs: "none", md: "block" },
                            borderLeft: "1px solid #B8D7FF",
                            borderRight: "1px solid #B8D7FF",
                            backgroundColor: "#fff",
                            px: 1.5,
                            pt: 1,
                          }}
                        >
                          <Grid container spacing={1.5} sx={{ mx: 0, width: "100%" }}>
                            <Grid item md={2.5}>
                              <Typography
                                variant="caption"
                                fontWeight={600}
                                color="text.secondary"
                              >
                                Product Name / SKU
                              </Typography>
                            </Grid>
                            <Grid item md={1.4}>
                              <Typography
                                variant="caption"
                                fontWeight={600}
                                color="text.secondary"
                              >
                                {formik.values.taxMode === "inclusive"
                      ? "Unit Price (Incl. VAT)"
                      : "Unit Price (Excl. VAT)"}
                              </Typography>
                            </Grid>
                            <Grid item md={1.5}>
                              <Typography
                                variant="caption"
                                fontWeight={600}
                                color="text.secondary"
                              >
                                Quantity
                              </Typography>
                            </Grid>
                            <Grid item md={1.2}>
                              <Typography
                                variant="caption"
                                fontWeight={600}
                                color="text.secondary"
                              >
                                Subtotal
                              </Typography>
                            </Grid>
                            <Grid item md={3.3}>
                              <Typography
                                variant="caption"
                                fontWeight={600}
                                color="text.secondary"
                              >
                                Discount (AED / %)
                              </Typography>
                            </Grid>
                            <Grid item md={1.6}>
                              <Typography
                                variant="caption"
                                fontWeight={600}
                                color="text.secondary"
                              >
                                Subtotal after Discount
                              </Typography>
                            </Grid>
                            <Grid item md={0.5} />
                          </Grid>
                        </Box>
                      </Grid>
                    )}
                    <Grid
                      container
                      spacing={1.5}
                      alignItems="center"
                      sx={{
                        mt: row.fromBundle ? 0 : 1,
                        ...(row.fromBundle && {
                          mx: 0,
                          width: "100%",
                          px: 1.5,
                          py: 1.25,
                          backgroundColor: "#fff",
                          borderLeft: "1px solid #B8D7FF",
                          borderRight: "1px solid #B8D7FF",
                          borderBottom: "1px solid #E5F0FF",
                          borderRadius: 0,
                        }),
                      }}
                    >
                      {/* Product Name / SKU — full width while picking a bundle
                    (selected bundle explodes into its own card layout, and
                    every other column below is hidden until then anyway, so
                    there's no reason to squeeze the picker into 2.5/12). */}
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={selectionMode === "bundle" && !row.productId ? 11 : 2.5}
                        sx={{ position: "relative" }}
                      >
                        <Typography
                          variant="caption"
                          sx={{
                            display: { xs: "block", md: "none" },
                            fontWeight: 500,
                          }}
                        >
                          Product Name / SKU
                        </Typography>
                        <Box sx={{ height: { xs: 0, md: 22 }, mb: { xs: 0, md: 0.5 } }} />
                        {selectionMode === "bundle" && !row.productId ? (
                          <Box sx={{ display: "flex", gap: 1, alignItems: "flex-start" }}>
                            <Autocomplete
                              key={`bundle-select-${idx}`}
                              fullWidth
                              openOnFocus
                              disabled={!formik.values.store_id || productListLoading}
                              options={bundleList}
                              getOptionLabel={(option) =>
                                option.product_name
                                  ? `${option.product_name} (SKU: ${option.sku || ""})`
                                  : ""
                              }
                              getOptionDisabled={(option) => !option.eligible}
                              isOptionEqualToValue={(option, value) =>
                                option.id === value.id
                              }
                              value={getBundleForRow(row)}
                              onChange={(e, newValue) =>
                                handleBundleSelect(idx, newValue)
                              }
                              renderOption={(props, option) => (
                                <li
                                  {...props}
                                  key={option.id}
                                  style={{
                                    display: "block",
                                    padding: "8px 12px",
                                    borderBottom: "1px solid #eee",
                                    opacity: option.eligible ? 1 : 0.6,
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      gap: 8,
                                    }}
                                  >
                                    <span style={{ fontWeight: 500, color: "#333" }}>
                                      {option.product_name}{" "}
                                      <span
                                        style={{ color: "#555", fontWeight: 400 }}
                                      >
                                        (SKU: {option.sku || "-"})
                                      </span>
                                    </span>
                                    <span
                                      style={{
                                        fontWeight: 600,
                                        color: "#0c54a0",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      {formatAED(getBundleStorePrice(option))}
                                    </span>
                                  </div>
                                  <div
                                    style={{
                                      marginTop: 4,
                                      display: "grid",
                                      gap: 2,
                                    }}
                                  >
                                    {(option.components || []).slice(0, 2).map((c) => (
                                      <div
                                        key={c.product_id}
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          alignItems: "baseline",
                                          gap: 8,
                                          fontSize: 12,
                                          color:
                                            (c.available ?? 0) >= c.required_per_bundle
                                              ? "#2e7d32"
                                              : "#c62828",
                                        }}
                                      >
                                        {/* min-width:0 lets this truncate instead of
                                      wrapping "x N" onto its own line, which
                                      used to land right under "Stock: N" and
                                      read as two different stock numbers. */}
                                        <span
                                          style={{
                                            minWidth: 0,
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                          }}
                                        >
                                          {c.product_name}
                                          {c.sku ? ` (SKU: ${c.sku})` : ""}
                                        </span>
                                        <span style={{ whiteSpace: "nowrap", flexShrink: 0 }}>
                                          Needs {c.required_per_bundle} · Stock:{" "}
                                          {c.available ?? 0}
                                        </span>
                                      </div>
                                    ))}
                                    {(option.components || []).length > 2 && (
                                      <Typography
                                        component="div"
                                        variant="caption"
                                        sx={{ color: "text.secondary" }}
                                      >
                                        +{(option.components || []).length - 2} more
                                        product(s)
                                      </Typography>
                                    )}
                                  </div>
                                  <div
                                    style={{
                                      marginTop: 4,
                                      fontSize: 12,
                                      fontWeight: 600,
                                      color: option.eligible ? "#2e7d32" : "#c62828",
                                    }}
                                  >
                                    {option.eligible
                                      ? `Available: ${option.max_qty} bundle(s)`
                                      : option.not_yet_started
                                        ? `Not available yet — starts ${dayjs(option.valid_from).format("DD-MM-YYYY")}`
                                        : option.is_expired
                                          ? `Expired on ${dayjs(option.valid_to).format("DD-MM-YYYY")}`
                                          : "Out of stock in this store"}
                                  </div>
                                  {/* "Check other stores" only helps for a stock
                                problem — a scheduling block applies
                                everywhere, so skip it for those. */}
                                  {!option.eligible && !option.not_yet_started && !option.is_expired && (
                                    <div style={{ marginTop: 4 }} onClick={(e) => e.stopPropagation()}>
                                      {(() => {
                                        const info = bundleStoreAvailability[option.id];
                                        if (!info) {
                                          return (
                                            <span
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                checkBundleOtherStores(option.id);
                                              }}
                                              style={{
                                                fontSize: 12,
                                                fontWeight: 600,
                                                color: "#0c54a0",
                                                textDecoration: "underline",
                                                cursor: "pointer",
                                              }}
                                            >
                                              Check other stores
                                            </span>
                                          );
                                        }
                                        if (info.loading) {
                                          return (
                                            <span style={{ fontSize: 12, color: "#666" }}>
                                              Checking other stores…
                                            </span>
                                          );
                                        }
                                        if (!info.byStore.length) {
                                          return (
                                            <span style={{ fontSize: 12, color: "#c62828" }}>
                                              Out of stock in every store
                                            </span>
                                          );
                                        }
                                        return (
                                          <span style={{ fontSize: 12, color: "#2e7d32", fontWeight: 600 }}>
                                            Available at:{" "}
                                            {info.byStore
                                              .map((s) => `${s.store_name} (${s.max_qty})`)
                                              .join(" · ")}
                                          </span>
                                        );
                                      })()}
                                    </div>
                                  )}
                                </li>
                              )}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label={
                                    formik.values.store_id
                                      ? "Select a Bundle"
                                      : "Select a store first"
                                  }
                                  fullWidth
                                  onBlur={() =>
                                    formik.setFieldTouched(
                                      `items[${idx}].productId`,
                                      true
                                    )
                                  }
                                  error={
                                    formik.touched.items?.[idx]?.productId &&
                                    Boolean(formik.errors.items?.[idx]?.productId)
                                  }
                                  helperText={
                                    formik.touched.items?.[idx]?.productId &&
                                    formik.errors.items?.[idx]?.productId
                                  }
                                />
                              )}
                              ListboxProps={{
                                style: { maxHeight: 260, overflowY: "auto" },
                              }}
                            />
                            <Tooltip title="View bundle details">
                              <span>
                                <IconButton
                                  sx={{ mt: 1 }}
                                  disabled={!getBundleForRow(row)}
                                  onClick={() => setBundleDetails(getBundleForRow(row))}
                                >
                                  <InfoOutlinedIcon />
                                </IconButton>
                              </span>
                            </Tooltip>
                          </Box>
                        ) : (
                          <Autocomplete
                            key={`product-select-${idx}`}
                            fullWidth
                            openOnFocus
                            disabled={
                              !formik.values.store_id || row.fromBundle || productListLoading
                            }
                            // In-stock products first, out-of-stock pushed to the
                            // bottom — Array.prototype.sort is stable, so within
                            // each group the original (search-relevance) order
                            // from fetchProductsWithStock is preserved.
                            options={[
                              ...(productList || []),
                              ...(row.productId &&
                                !productList.some((p) => p.id === row.productId)
                                ? [{ ...row, id: row.productId }]
                                : []),
                            ].sort(
                              (a, b) => Number(b.inStock) - Number(a.inStock)
                            )}
                            getOptionLabel={(option) =>
                              option.product_name
                                ? `${option.product_name} ${option.sku || ""}`
                                : ""
                            }
                            getOptionDisabled={(option) => !option.inStock}
                            isOptionEqualToValue={(option, value) =>
                              option.id === value.id
                            }
                            value={
                              productList.find((p) => p.id === row.productId) || null
                            }
                            inputValue={searchTerm[idx]}
                            onInputChange={(e, value, reason) => {
                              const updated = [...searchTerm];
                              updated[idx] = value;
                              setSearchTerm(updated);

                              // Only search on typing
                              if (reason === "input") {
                                debounce(() => {
                                  fetchProductsWithStock(
                                    formik.values.store_id || null,
                                    value
                                  );
                                });
                              }

                              // Clear search
                              if (reason === "clear" || reason === "reset") {
                                fetchProductsWithStock(
                                  formik.values.store_id || null,
                                  ""
                                );
                              }
                            }}
                            onChange={(e, newValue) => {
                              if (newValue) {
                                handleProductSelect(idx, newValue);
                              } else {
                                const updatedItems = [...formik.values.items];
                                updatedItems[idx] = {
                                  ...updatedItems[idx],
                                  productId: null,
                                  isBundle: false,
                                  bundleId: null,
                                  sellingPrice: 0,
                                  quantity: 0,
                                  subtotal: 0,
                                };
                                formik.setFieldValue("items", updatedItems);
                                recalcSummary(updatedItems);
                              }
                            }}
                            renderOption={(props, option, { selected }) => {
                              const size = option.size || "NA";
                              const color = option.color || "NA";

                              return (
                                <li
                                  {...props}
                                  key={option.id}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "6px 10px",
                                    gap: 10,
                                    borderBottom: "1px solid #eee",
                                    backgroundColor: selected ? "#e3f2fd" : "#fff",
                                    borderRadius: 4,
                                    cursor: "pointer",
                                    fontSize: 14,
                                  }}
                                >
                                  {/* Product Image */}
                                  <img
                                    src={option.product_image}
                                    alt={option.product_name}
                                    style={{
                                      width: 36,
                                      height: 36,
                                      objectFit: "cover",
                                      borderRadius: 6,
                                      border: "1px solid #ccc",
                                    }}
                                  />

                                  {/* Product Details */}
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      lineHeight: 1.2,
                                    }}
                                  >
                                    <span style={{ fontWeight: 500, color: "#333" }}>
                                      {option.product_name}{" "}
                                      <span style={{ color: "#555", fontWeight: 400 }}>
                                        {" "}
                                        (SKU: {option.sku})
                                      </span>
                                    </span>

                                    <span style={{ fontSize: 12, color: "#007BFF" }}>
                                      Size: {size}, Colour: {color}
                                    </span>

                                    <span
                                      style={{
                                        color: option.inStock ? "green" : "red",
                                        fontWeight: 500,
                                        fontSize: 12,
                                      }}
                                    >
                                      {option.inStock
                                        ? option.reserved > 0
                                          ? `Available: ${option.atp ?? option.quantity
                                          } · Reserved: ${option.reserved
                                          } · In Stock: ${option.quantity}${option.expired > 0 ? ` · ${option.expired} expired` : ""}`
                                          : `In Stock: ${option.quantity}${option.expired > 0 ? ` · ${option.expired} expired` : ""}`
                                        : option.expired > 0
                                          ? `Expired: ${option.expired} unit${option.expired === 1 ? "" : "s"} past expiry — not sellable${option.reserved > 0
                                            ? ` · ${option.reserved} reserved`
                                            : ""
                                          }`
                                          : `Out of Stock${option.reserved > 0
                                            ? ` · ${option.reserved} reserved`
                                            : ""
                                          }`}
                                    </span>
                                  </div>
                                </li>
                              );
                            }}
                            renderInput={(params) => {
                              const selectedProduct = productList.find(
                                (p) => p.id === row.productId
                              );

                              return (
                                <TextField
                                  {...params}
                                  size="small"
                                  label={
                                    selectedProduct
                                      ? ""
                                      : productListLoading
                                        ? "Loading products…"
                                        : formik.values.store_id
                                          ? "Select a Product"
                                          : "Select a store first"
                                  }
                                  fullWidth
                                  sx={{
                                    "& .MuiOutlinedInput-notchedOutline": {
                                      border: selectedProduct
                                        ? "none"
                                        : "1px solid #E3E6EA",
                                    },
                                    "& .MuiOutlinedInput-root": {
                                      backgroundColor: selectedProduct
                                        ? "transparent"
                                        : "#FCFCFD",
                                    },
                                  }}
                                  onBlur={() =>
                                    formik.setFieldTouched(
                                      `items[${idx}].productId`,
                                      true
                                    )
                                  }
                                  error={
                                    formik.touched.items?.[idx]?.productId &&
                                    Boolean(formik.errors.items?.[idx]?.productId)
                                  }
                                  helperText={
                                    formik.touched.items?.[idx]?.productId &&
                                    formik.errors.items?.[idx]?.productId
                                  }
                                  FormHelperTextProps={{
                                    sx: { position: "absolute", top: "100%", left: 0, m: 0, whiteSpace: "nowrap" },
                                  }}
                                  InputProps={{
                                    ...params.InputProps,
                                    startAdornment: selectedProduct ? (
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: 10,
                                          paddingLeft: 2,
                                          minWidth: 0,
                                          flex: 1,
                                        }}
                                      >
                                        <img
                                          src={selectedProduct.product_image}
                                          alt={selectedProduct.product_name}
                                          style={{
                                            width: 36,
                                            height: 36,
                                            borderRadius: "50%",
                                            objectFit: "cover",
                                            border: "1px solid rgba(0,0,0,0.08)",
                                            flexShrink: 0,
                                          }}
                                        />

                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            minWidth: 0,
                                          }}
                                        >
                                          <span
                                            style={{
                                              fontSize: 14,
                                              fontWeight: 600,
                                              color: "#101828",
                                              display: "-webkit-box",
                                              WebkitLineClamp: 2,
                                              WebkitBoxOrient: "vertical",
                                              overflow: "hidden",
                                              lineHeight: 1.25,
                                            }}
                                          >
                                            {selectedProduct.product_name}
                                          </span>
                                          <span
                                            style={{
                                              fontSize: 12,
                                              color: "#2F5FED",
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                            }}
                                          >
                                            {selectedProduct.sku} ·{" "}
                                            {selectedProduct.size || "NA"},{" "}
                                            {selectedProduct.color || "NA"}
                                          </span>
                                        </div>
                                      </div>
                                    ) : null,

                                    endAdornment: (
                                      <>
                                        {!formik.values.items[idx].productId &&
                                          searchTerm[idx] && (
                                            <IconButton
                                              size="small"
                                              onClick={(event) => {
                                                event.stopPropagation();
                                                const updated = [...searchTerm];
                                                updated[idx] = "";
                                                setSearchTerm(updated);
                                                fetchProductsWithStock(
                                                  formik.values.store_id || null,
                                                  ""
                                                );
                                              }}
                                            >
                                              <CloseIcon fontSize="small" />
                                            </IconButton>
                                          )}
                                        {params.InputProps.endAdornment}
                                      </>
                                    ),
                                  }}
                                  inputProps={{
                                    ...params.inputProps,
                                    value: selectedProduct
                                      ? ""
                                      : params.inputProps.value,
                                    style: selectedProduct
                                      ? { flexGrow: 0, width: 0, minWidth: 0, padding: 0 }
                                      : params.inputProps.style,
                                  }}
                                />
                              );
                            }}
                            ListboxProps={{
                              style: { maxHeight: 200, overflowY: "auto" },
                            }}
                          />
                        )}
                      </Grid>

                      {/* Unit Price (Exclusive of VAT) */}
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={1.5}
                        sx={{
                          position: "relative",
                          display:
                            selectionMode === "bundle" && !row.productId
                              ? "none"
                              : undefined,
                        }}
                      >
                        <Typography
                          variant="caption"
                          sx={{
                            display: { xs: "block", md: "none" },
                            fontWeight: 500,
                          }}
                        >
                          {formik.values.taxMode === "inclusive"
                      ? "Unit Price (Incl. VAT)"
                      : "Unit Price (Excl. VAT)"}
                        </Typography>
                        {/* Empty fixed-height slot — kept (not removed) so
                            this column still lines up with the matching
                            reserved slot in every sibling column below.
                            Unit Price never shows tax math here now;
                            that's Summary-only. */}
                        <Box sx={{ height: { xs: 0, md: 22 }, mb: { xs: 0, md: 0.5 } }} />

                        <TextField
                          fullWidth
                          size="small"
                          type="number"
                          // ?? not || — a genuine 0 price must still render as
                          // "0", not blank (0 is falsy, so || was hiding it).
                          value={row.sellingPrice ?? ""}
                          onChange={(e) => {
                            const value = Math.min(
                              MAX_MONEY_VALUE,
                              parseFloat(e.target.value) || 0
                            );
                            const updated = [...formik.values.items];
                            updated[idx] = {
                              ...updated[idx],
                              sellingPrice: value,
                              subtotal: (
                                value * (parseFloat(updated[idx].quantity) || 0)
                              ).toFixed(2),
                            };
                            formik.setFieldValue("items", updated);
                            recalcSummary(updated);
                          }}
                          onFocus={(e) => e.target.select()}
                          onBlur={() =>
                            formik.setFieldTouched(`items[${idx}].sellingPrice`, true)
                          }
                          error={
                            formik.touched.items?.[idx]?.sellingPrice &&
                            Boolean(formik.errors.items?.[idx]?.sellingPrice)
                          }
                          helperText={
                            formik.touched.items?.[idx]?.sellingPrice &&
                            formik.errors.items?.[idx]?.sellingPrice
                          }
                          FormHelperTextProps={{
                            sx: { position: "absolute", top: "100%", left: 0, m: 0, whiteSpace: "nowrap" },
                          }}
                        />
                      </Grid>

                      {/* Quantity */}
                      <Grid
                        item
                        xs={6}
                        sm={6}
                        md={1.2}
                        sx={{
                          position: "relative",
                          display:
                            selectionMode === "bundle" && !row.productId
                              ? "none"
                              : undefined,
                        }}
                      >
                        <Typography
                          variant="caption"
                          sx={{
                            display: { xs: "block", md: "none" },
                            fontWeight: 500,
                          }}
                        >
                          Quantity
                        </Typography>
                        <Box sx={{ height: { xs: 0, md: 22 }, mb: { xs: 0, md: 0.5 } }} />
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            height: 40,
                            border: "1px solid",
                            borderColor:
                              formik.touched.items?.[idx]?.quantity &&
                                formik.errors.items?.[idx]?.quantity
                                ? "error.main"
                                : "#d8dee6",
                            borderRadius: 1,
                            overflow: "hidden",
                            backgroundColor: "#FCFCFD",
                            width: "100%",
                          }}
                        >
                          <IconButton
                            size="small"
                            onClick={() =>
                              handleQuantityChange(
                                idx,
                                String(Math.max((Number(row.quantity) || 0) - 1, 0))
                              )
                            }
                            sx={{ borderRadius: 0, width: 28, height: "100%", flexShrink: 0, px: 0 }}
                          >
                            <Typography component="span" sx={{ fontSize: 16, fontWeight: 700, lineHeight: 1 }}>
                              −
                            </Typography>
                          </IconButton>
                          <input
                            value={row.quantity || ""}
                            onChange={(e) => handleQuantityChange(idx, e.target.value)}
                            onFocus={(e) => e.target.select()}
                            onBlur={() =>
                              formik.setFieldTouched(`items[${idx}].quantity`, true)
                            }
                            inputMode="numeric"
                            style={{
                              flex: 1,
                              width: 0,
                              minWidth: 20,
                              textAlign: "center",
                              border: "none",
                              outline: "none",
                              background: "transparent",
                              fontSize: 14,
                              fontWeight: 600,
                              fontFamily: "inherit",
                            }}
                          />
                          <IconButton
                            size="small"
                            onClick={() =>
                              handleQuantityChange(
                                idx,
                                String((Number(row.quantity) || 0) + 1)
                              )
                            }
                            sx={{ borderRadius: 0, width: 28, height: "100%", flexShrink: 0, px: 0 }}
                          >
                            <Typography component="span" sx={{ fontSize: 16, fontWeight: 700, lineHeight: 1 }}>
                              +
                            </Typography>
                          </IconButton>
                        </Box>
                        {formik.touched.items?.[idx]?.quantity &&
                          formik.errors.items?.[idx]?.quantity && (
                            <Typography
                              variant="caption"
                              color="error"
                              sx={{
                                position: "absolute",
                                top: "100%",
                                left: 4,
                                mt: 0.5,
                                whiteSpace: "nowrap",
                              }}
                            >
                              {formik.errors.items?.[idx]?.quantity}
                            </Typography>
                          )}
                      </Grid>

                      {/* Subtotal (gross — selling price × quantity, before any discount) */}
                      <Grid
                        item
                        xs={6}
                        sm={6}
                        md={1.6}
                        sx={{
                          display:
                            selectionMode === "bundle" && !row.productId
                              ? "none"
                              : undefined,
                        }}
                      >
                        <Typography
                          variant="caption"
                          sx={{
                            display: { xs: "block", md: "none" },
                            fontWeight: 500,
                          }}
                        >
                          Subtotal
                        </Typography>
                        <Box sx={{ height: { xs: 0, md: 22 }, mb: { xs: 0, md: 0.5 } }} />
                        <Box
                          sx={{
                            height: 40,
                            borderRadius: 1,
                            backgroundColor: "#F7F8FA",
                            border: "1px dashed #cbd1d9",
                            display: "flex",
                            alignItems: "center",
                            px: 1.5,
                            fontSize: 14,
                            fontWeight: 600,
                            color: "text.secondary",
                          }}
                        >
                          {formatAED(
                            (parseFloat(row.sellingPrice) || 0) *
                            (parseFloat(row.quantity) || 0)
                          )}
                        </Box>
                      </Grid>

                      {/* Discount (value) — a bundle-mode sub-row has no field here,
                    its discount is entered once on the bundle header instead.
                    md is 2.6, not the 3.3 it used to be — the row's column
                    widths (2.5 + 1.5 + 1.6 + 1.2 + 2.6 + 1.6 + 1, incl. the
                    trailing Delete Button column below) now sum to exactly
                    12; at 3.3 the row overflowed to 12.7/12 and Grid wrapped
                    the Delete button onto its own line under every row. */}
                      <Grid
                        item
                        xs={6}
                        sm={6}
                        md={2.6}
                        sx={{
                          position: "relative",
                          display:
                            selectionMode === "bundle" && !row.productId
                              ? "none"
                              : undefined,
                        }}
                      >
                        <Typography
                          variant="caption"
                          sx={{
                            display: { xs: "block", md: "none" },
                            fontWeight: 500,
                            color: "text.secondary",
                          }}
                        >
                          Discount (Amount or %)
                        </Typography>
                        <Box sx={{ height: { xs: 0, md: 22 }, mb: { xs: 0, md: 0.5 } }} />
                        {((row.fromBundle && (row.discountMode || "bundle") === "item") ||
                          (!row.fromBundle && row.productId)) ? (
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "stretch",
                              height: 40,
                              border: "1px solid #d8dee6",
                              borderRadius: 1,
                              overflow: "hidden",
                              backgroundColor: "#FCFCFD",
                            }}
                          >
                            <TextField
                              size="small"
                              placeholder="0.00"
                              disabled={
                                selectionMode === "product" &&
                                formik.values.discountType === "total"
                              }
                              value={row.discountValue ?? ""}
                              onFocus={(e) => e.target.select()}
                              onChange={(e) => {
                                const gross =
                                  (parseFloat(row.sellingPrice) || 0) *
                                  (parseFloat(row.quantity) || 0);
                                const valStr = sanitizeMoneyInput(
                                  e.target.value,
                                  gross > 0 ? gross : MAX_MONEY_VALUE
                                );
                                const numVal = parseFloat(valStr) || 0;
                                const pct = gross > 0 ? ((numVal / gross) * 100).toFixed(2) : "";

                                if (formik.values.discountType !== "item") {
                                  formik.setFieldValue("discountType", "item");
                                  formik.setFieldValue("discount", 0);
                                  formik.setFieldValue("discountPercent", 0);
                                }

                                const updated = [...formik.values.items];
                                updated[idx] = {
                                  ...updated[idx],
                                  discountUnit: "amount",
                                  discountValue: valStr,
                                  discountPercent: pct,
                                };
                                recalcSummary(updated);
                              }}
                              variant="standard"
                              InputProps={{
                                disableUnderline: true,
                                endAdornment: (
                                  <InputAdornment position="end" sx={{ typography: "caption", color: "text.secondary", fontWeight: 600 }}>
                                    AED
                                  </InputAdornment>
                                ),
                              }}
                              inputProps={{ inputMode: "decimal", style: { textAlign: "right" } }}
                              sx={{ flex: 1.2, minWidth: 70, px: 1.5, "& .MuiInputBase-root": { height: "100%" } }}
                            />
                            <Divider orientation="vertical" flexItem />
                            <TextField
                              size="small"
                              placeholder="0"
                              disabled={
                                selectionMode === "product" &&
                                formik.values.discountType === "total"
                              }
                              value={row.discountPercent ?? ""}
                              onFocus={(e) => e.target.select()}
                              onChange={(e) => {
                                const gross =
                                  (parseFloat(row.sellingPrice) || 0) *
                                  (parseFloat(row.quantity) || 0);
                                const pctStr = sanitizePercentInput(e.target.value);
                                const pctNum = parseFloat(pctStr) || 0;
                                const val = gross > 0 ? ((gross * pctNum) / 100).toFixed(2) : "";

                                if (formik.values.discountType !== "item") {
                                  formik.setFieldValue("discountType", "item");
                                  formik.setFieldValue("discount", 0);
                                  formik.setFieldValue("discountPercent", 0);
                                }

                                const updated = [...formik.values.items];
                                updated[idx] = {
                                  ...updated[idx],
                                  discountUnit: "percent",
                                  discountPercent: pctStr,
                                  discountValue: val,
                                };
                                recalcSummary(updated);
                              }}
                              variant="standard"
                              InputProps={{
                                disableUnderline: true,
                                endAdornment: (
                                  <InputAdornment position="end" sx={{ typography: "caption", color: "text.secondary", fontWeight: 600 }}>
                                    %
                                  </InputAdornment>
                                ),
                              }}
                              inputProps={{ inputMode: "decimal", style: { textAlign: "right" } }}
                              sx={{ flex: 1, minWidth: 55, px: 1.5, "& .MuiInputBase-root": { height: "100%" } }}
                            />
                          </Box>
                        ) : (
                          <Box
                            sx={{
                              height: 40,
                              borderRadius: 1,
                              backgroundColor: "#F7F8FA",
                              border: "1px dashed #cbd1d9",
                              display: "flex",
                              alignItems: "center",
                              px: 1.5,
                              fontSize: 14,
                              color: "text.disabled",
                            }}
                          >
                            —
                          </Box>
                        )}
                      </Grid>

                      {/* Subtotal after Discount (net — what's actually billed) */}
                      <Grid
                        item
                        xs={6}
                        sm={6}
                        md={1.6}
                        sx={{
                          display:
                            selectionMode === "bundle" && !row.productId
                              ? "none"
                              : undefined,
                        }}
                      >
                        <Typography
                          variant="caption"
                          sx={{
                            display: { xs: "block", md: "none" },
                            fontWeight: 500,
                          }}
                        >
                          Subtotal after Discount
                        </Typography>
                        <Box sx={{ height: { xs: 0, md: 22 }, mb: { xs: 0, md: 0.5 } }} />
                        <Box
                          sx={{
                            height: 40,
                            borderRadius: 1,
                            backgroundColor: "#EEF4FF",
                            border: "1px dashed #B8D7FF",
                            display: "flex",
                            alignItems: "center",
                            px: 1.5,
                            fontSize: 14,
                            fontWeight: 700,
                            color: "#0c54a0",
                          }}
                        >
                          {formatAED(row.subtotal)}
                        </Box>
                      </Grid>

                      {/* Delete Button */}
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={1}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-end",
                        }}
                      >
                        {!row.fromBundle && (
                          <IconButton
                            onClick={() => removeRow(idx)}
                            disabled={formik.values.items.length === 1}
                          >
                            <DeleteOutlineOutlinedIcon />
                          </IconButton>
                        )}
                      </Grid>
                    </Grid>

                    {isLastBundleRow &&
                      (() => {
                        const grp = formik.values.items.filter(
                          (it) => it.bundleGroupId === row.bundleGroupId
                        );
                        const grpMode = row.discountMode || "bundle";
                        const groupGrossTotal = grp.reduce(
                          (s, it) =>
                            s +
                            (parseFloat(it.sellingPrice || 0) || 0) *
                            (parseFloat(it.quantity || 0) || 0),
                          0
                        );
                        const groupAfterItemDisc =
                          grpMode === "item"
                            ? grp.reduce((s, it) => {
                              const gross =
                                parseFloat(it.sellingPrice || 0) *
                                (parseFloat(it.quantity || 0) || 0);
                              const itDisc = discountAmountFromPercent(
                                gross,
                                it.discountPercent
                              );
                              return s + (gross - itDisc);
                            }, 0)
                            : Math.max(
                              groupGrossTotal -
                              discountAmountFromPercent(groupGrossTotal, row.bundleDiscount),
                              0
                            );
                        return (
                          <Grid item xs={12} sx={{ mt: 0 }}>
                            <Box
                              sx={{
                                backgroundColor: "#EEF4FF",
                                border: "1px solid #B8D7FF",
                                borderTop: "none",
                                px: 3,
                                py: 1.25,
                                borderRadius: "0 0 8px 8px",
                                display: "flex",
                                justifyContent: "flex-end",
                                alignItems: "center",
                              }}
                            >
                              <Typography sx={{ fontWeight: 700, color: "#0c54a0" }}>
                                Bundle total {formatAED(groupAfterItemDisc)}
                              </Typography>
                            </Box>
                          </Grid>
                        );
                      })()}
                  </Fragment>
                );
              })}

              <Box sx={{ mt: 2 }}>
                <Button
                  startIcon={<AddCircleOutlineIcon />}
                  onClick={addRow}
                  variant="outlined"
                >
                  {selectionMode === "bundle" ? "Add Bundle" : "Add Product"}
                </Button>
              </Box>

              {/* Removed global bundle discount: per-bundle discounts are entered on each bundle header */}

            </Box>

            {/* Summary */}
            <Box
              sx={{
                border: "1px solid #E3E6EA",
                borderRadius: "14px",
                p: { xs: 2, sm: 3.5 },
                mb: 3,
                backgroundColor: "#fff",
                boxShadow: "0 1px 2px rgba(16,24,40,0.04)",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1.25,
                  mb: 2.5,
                }}
              >
                <Box
                  sx={{
                    width: 26,
                    height: 26,
                    borderRadius: "7px",
                    bgcolor: "#EEF2FF",
                    color: "#2F5FED",
                    fontSize: 12,
                    fontWeight: 700,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  3
                </Box>
                <Typography sx={{ fontWeight: 700, fontSize: 15 }}>
                  Summary
                </Typography>
              </Box>
              <Grid container spacing={2.5} alignItems="flex-start">
                <Grid item xs={12} md={5}></Grid>
                <Grid item xs={12} md={7}>
                  {/* One consistent 3-column grid per row: label | control |
                    amount(right). The running total reads top-to-bottom:
                    Subtotal - Discount + Tax + Shipping = Grand Total. Subtotal
                    is the GROSS line total (pre-discount) so it stays fixed when
                    the discount changes; the discount is its own line right
                    below it, and Tax reads as a % of the post-discount amount. */}

                  {/* Subtotal (gross, pre-discount) */}
                  <Grid container spacing={1} alignItems="center" sx={{ mt: 1 }}>
                    <Grid item xs={9}>
                      <Typography color="text.secondary">Subtotal</Typography>
                    </Grid>
                    <Grid item xs={3} textAlign="right">
                      <Typography>
                        {(() => {
                          // Always the plain net figure — tax math only
                          // shows up in the Tax / Grand Total rows below,
                          // never here.
                          const grossSubtotal = formik.values.items.reduce(
                            (s, r) => s + (parseFloat(r.subtotal) || 0),
                            0
                          );
                          return formatAED(grossSubtotal);
                        })()}
                      </Typography>
                    </Grid>
                  </Grid>

                  {/* Discount Method now lives at the top of the Product
                      Selection card (set before entering line items) — see
                      the block right after the Products/Bundle toggle. */}

                  {/* Special Discount */}
                  <Grid container spacing={1} alignItems="center" sx={{ mt: 1.5 }}>
                    <Grid item xs={3.5}>
                      <Typography color="text.secondary">
                        Special Discount
                      </Typography>
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Value (AED)"
                        name="discount"
                        disabled={
                          selectionMode === "product" &&
                          formik.values.discountType !== "total"
                        }
                        value={formik.values.discount}
                        onChange={(e) => {
                          const subtotal = formik.values.items.reduce(
                            (sum, row) => sum + (parseFloat(row.subtotal) || 0),
                            0
                          );
                          const maxAllowed = Math.min(MAX_MONEY_VALUE, subtotal);
                          const value = sanitizeMoneyInput(
                            e.target.value,
                            maxAllowed
                          );
                          const numVal = parseFloat(value) || 0;
                          const pct = subtotal > 0 ? ((numVal / subtotal) * 100).toFixed(2) : "";

                          recalcSummary(
                            formik.values.items,
                            formik.values.shippingCharges,
                            value
                          );
                          formik.setFieldValue("discount", value);
                          formik.setFieldValue("discountPercent", pct);
                        }}
                        onFocus={(e) => e.target.select()}
                        inputProps={{
                          inputMode: "decimal",
                        }}
                        onBlur={(e) => {
                          formik.setFieldTouched("discount", true);
                          let val = parseFloat(e.target.value || 0);
                          if (!isNaN(val)) {
                            val = val.toFixed(2);
                            formik.setFieldValue("discount", val);
                          } else {
                            formik.setFieldValue("discount", "");
                          }
                        }}
                        error={
                          formik.touched.discount &&
                          Boolean(formik.errors.discount)
                        }
                        helperText={
                          formik.touched.discount && formik.errors.discount
                        }
                      />
                    </Grid>
                    <Grid item xs={2.5}>
                      <TextField
                        fullWidth
                        size="small"
                        label="%"
                        name="discountPercent"
                        disabled={
                          selectionMode === "product" &&
                          formik.values.discountType !== "total"
                        }
                        value={formik.values.discountPercent || ""}
                        onChange={(e) => {
                          const pct = sanitizePercentInput(e.target.value);
                          const subtotal = formik.values.items.reduce(
                            (sum, row) => sum + (parseFloat(row.subtotal) || 0),
                            0
                          );
                          const discVal = subtotal > 0 ? discountAmountFromPercent(subtotal, pct) : 0;
                          const valStr = discVal > 0 ? discVal.toFixed(2) : "0.00";

                          recalcSummary(
                            formik.values.items,
                            formik.values.shippingCharges,
                            valStr
                          );
                          formik.setFieldValue("discountPercent", pct);
                          formik.setFieldValue("discount", valStr);
                        }}
                        onFocus={(e) => e.target.select()}
                        InputProps={{
                          endAdornment: <InputAdornment position="end">%</InputAdornment>,
                        }}
                        inputProps={{ inputMode: "decimal", max: 100, min: 0 }}
                      />
                    </Grid>
                    <Grid item xs={3} textAlign="right">
                      <Typography>
                        {Number(formik.values.discount) > 0 ? "- " : ""}
                        {formatAED(formik.values.discount || 0)}
                      </Typography>
                    </Grid>
                  </Grid>

                  {/* Tax Mode and Tax Rate now live at the top of the
                      Product Selection card (set before entering line
                      items) — see the block right after the Products/
                      Bundle toggle. */}

                  {/* Amount before VAT (only meaningful in inclusive mode,
                      where Tax below is extracted out of Grand Total rather
                      than added on top) */}
                  {formik.values.taxMode === "inclusive" && (
                    <>
                    <Divider sx={{ my: 1.5 }} />
                    <Grid container spacing={1} alignItems="center">
                      <Grid item xs={9}>
                        <Typography color="text.secondary">
                          Amount before VAT
                        </Typography>
                      </Grid>
                      <Grid item xs={3} textAlign="right">
                        <Typography>
                          {formatAED(formik.values.subtotalSummary || 0)}
                        </Typography>
                      </Grid>
                    </Grid>
                    </>
                  )}

                  {/* Tax */}
                  <Grid container spacing={1} alignItems="center" sx={{ mt: 1.5 }}>
                    <Grid item xs={9}>
                      <Typography color="text.secondary">
                        Tax ({parseFloat(formik.values.taxType) || 0}%)
                      </Typography>
                    </Grid>
                    <Grid item xs={3} textAlign="right">
                      <Typography>
                        {Number(formik.values.taxAmount) > 0 ? "+ " : ""}
                        {formatAED(formik.values.taxAmount)}
                      </Typography>
                    </Grid>
                  </Grid>

                  {/* Shipping Charges */}
                  <Grid container spacing={1} alignItems="center" sx={{ mt: 1.5 }}>
                    <Grid item xs={6}>
                      <Typography color="text.secondary">
                        Shipping Charges
                      </Typography>
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                        fullWidth
                        size="small"
                        name="shippingCharges"
                        type="number"
                        value={formik.values.shippingCharges}
                        inputProps={{
                          inputMode: "decimal",
                        }}
                        onChange={(e) => {
                          const value = sanitizeMoneyInput(
                            e.target.value,
                            MAX_MONEY_VALUE
                          );

                          recalcSummary(
                            formik.values.items,
                            value, // shippingOverride
                            formik.values.discount, // discountOverride
                            formik.values.taxType // taxTypeOverride
                          );
                          formik.setFieldValue("shippingCharges", value);
                        }}
                        onFocus={(e) => e.target.select()}
                        onBlur={(e) => {
                          formik.setFieldTouched("shippingCharges", true);
                          let val = parseFloat(e.target.value || 0);
                          if (!isNaN(val)) {
                            val = val.toFixed(2);
                            formik.setFieldValue("shippingCharges", val);
                          } else {
                            formik.setFieldValue("shippingCharges", "");
                          }
                        }}
                        error={
                          formik.touched.shippingCharges &&
                          Boolean(formik.errors.shippingCharges)
                        }
                        helperText={
                          formik.touched.shippingCharges &&
                          formik.errors.shippingCharges
                        }
                      />
                    </Grid>
                    <Grid item xs={3} textAlign="right">
                      <Typography>
                        {Number(formik.values.shippingCharges) > 0 ? "+ " : ""}
                        {formatAED(formik.values.shippingCharges || 0)}
                      </Typography>
                    </Grid>
                  </Grid>

                  <Divider sx={{ my: 1.5 }} />

                  {/* Grand Total is always a plain, read-only result — never
                      directly editable, in either tax mode. It's driven
                      entirely by the product rows' own prices above: what
                      changes between Exclusive and Inclusive is how those
                      unit prices are READ (see recalcSummary), not some
                      separate typed target that gets back-solved into a
                      discount. */}
                  <Grid container spacing={1} alignItems="center">
                    <Grid item xs={9}>
                      <Typography fontWeight={700}>Grand Total</Typography>
                    </Grid>
                    <Grid item xs={3} textAlign="right">
                      <Typography fontWeight={700}>
                        {formatAED(formik.values.grandTotal)}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

            </Box>

            {/* Payment & Notes */}
            <Box
              sx={{
                border: "1px solid #E3E6EA",
                borderRadius: "14px",
                p: { xs: 2, sm: 3.5 },
                mb: 3,
                backgroundColor: "#fff",
                boxShadow: "0 1px 2px rgba(16,24,40,0.04)",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1.25,
                  mb: 2.5,
                }}
              >
                <Box
                  sx={{
                    width: 26,
                    height: 26,
                    borderRadius: "7px",
                    bgcolor: "#EEF2FF",
                    color: "#2F5FED",
                    fontSize: 12,
                    fontWeight: 700,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  4
                </Box>
                <Typography sx={{ fontWeight: 700, fontSize: 15 }}>
                  Payment & Notes
                </Typography>
              </Box>

              <Grid container spacing={2.5} alignItems="flex-start">
                {/* Row 1 — how it is paid. Fields to the right depend on the type. */}
                <Grid item xs={12} md={4}>
                  <FormControl
                    fullWidth
                    error={
                      formik.touched.payment_type &&
                      Boolean(formik.errors.payment_type)
                    }
                  >
                    <InputLabel id="payment-type-label">Payment Type</InputLabel>
                    <Select
                      labelId="payment-type-label"
                      id="payment_type"
                      name="payment_type"
                      value={formik.values.payment_type || ""}
                      label="Payment Type"
                      onChange={(e) => {
                        formik.handleChange(e);
                        if (e.target.value === 1) {
                          formik.setFieldValue("paymentMethod", "");
                          // Give it a sensible starting point the user can
                          // change below — not left blank.
                          if (!formik.values.creditDays) {
                            formik.setFieldValue("creditDays", 15);
                            formik.setFieldValue(
                              "dueDate",
                              dayjs(formik.values.orderDate || undefined)
                                .add(15, "day")
                                .format("YYYY-MM-DD")
                            );
                          }
                        }
                      }}
                      onBlur={formik.handleBlur}
                    >
                      {/* Credit is approved per document: on a new document it
                        is always selectable and goes to Admin on submit; on
                        edit it stays available only if the document was
                        already approved for credit. */}
                      <MenuItem value={1} disabled={(isEdit && !wasCredit) || advanceCoversTotal}>
                        Credit Payment Terms
                      </MenuItem>
                      <MenuItem value={2}>Immediate Payment</MenuItem>
                    </Select>
                    {formik.touched.payment_type && formik.errors.payment_type && (
                      <FormHelperText>{formik.errors.payment_type}</FormHelperText>
                    )}
                  </FormControl>
                </Grid>

                {/* Immediate payment, paid now: method + transaction id (+ proof below).
                    Hidden when an advance already covers everything — the advance
                    rows hold the method / reference / proof then. */}
                {formik.values.payment_type == 2 && !advanceCoversTotal && (
                  <>
                    <Grid item xs={12} md={4}>
                      <TextField
                        select
                        fullWidth
                        label="Payment Method"
                        name="paymentMethod"
                        value={formik.values.paymentMethod || ""}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.paymentMethod && Boolean(formik.errors.paymentMethod)}
                        helperText={formik.touched.paymentMethod && formik.errors.paymentMethod}
                      >
                        {paymentOptions.map((opt) => (
                          <MenuItem key={opt.value} value={opt.value}>
                            {opt.label}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                    {formik.values.paymentMethod && (
                      <>
                        <Grid item xs={12} md={4}>
                          <TextField
                            fullWidth
                            label="Transaction Id"
                            name="paymentReferenceNo"
                            value={formik.values.paymentReferenceNo || ""}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                        </Grid>
                        <Grid item xs={12} md={8}>
                          <PaymentAttachmentUpload
                            height={48}
                            url={formik.values.paymentAttachmentUrl}
                            name={formik.values.paymentAttachmentName}
                            uploading={formik.values.paymentAttachmentUploading}
                            uploadApi={uploadToVercelAPI}
                            onUploadStart={() =>
                              formik.setFieldValue("paymentAttachmentUploading", true)
                            }
                            onUploadSuccess={({ url, name }) => {
                              formik.setFieldValue("paymentAttachmentUrl", url);
                              formik.setFieldValue("paymentAttachmentName", name);
                              formik.setFieldValue("paymentAttachmentUploading", false);
                            }}
                            onUploadError={(message) => {
                              formik.setFieldValue("paymentAttachmentUploading", false);
                              alertRef.current.triggerAlert(
                                JSON.stringify({ message, messageType: "error" })
                              );
                            }}
                            onRemove={() => {
                              formik.setFieldValue("paymentAttachmentUrl", "");
                              formik.setFieldValue("paymentAttachmentName", "");
                            }}
                          />
                        </Grid>
                      </>
                    )}
                  </>
                )}

                {/* Credit: days requested + auto due date. Creating: the days are
                    editable and go to Admin; editing an approved document: locked. */}
                {formik.values.payment_type == 1 && (
                  <>
                    <Grid item xs={12} sm={6} md={4}>
                      <TextField
                        label={isEdit ? "Credit Days (approved by Admin)" : "Credit Days Requested"}
                        type="number"
                        value={formik.values.creditDays || ""}
                        onChange={(e) => {
                          if (isEdit) return;
                          let days = parseInt(e.target.value, 10);
                          if (Number.isNaN(days)) days = "";
                          // Cap at 10 years — an unbounded value here overflows
                          // dayjs().add() into "Invalid Date" on the Due Date
                          // field below.
                          if (days && days > MAX_CREDIT_DAYS) days = MAX_CREDIT_DAYS;
                          formik.setFieldValue("creditDays", days);
                          formik.setFieldValue(
                            "dueDate",
                            days
                              ? dayjs(formik.values.orderDate || undefined)
                                  .add(Number(days), "day")
                                  .format("YYYY-MM-DD")
                              : ""
                          );
                        }}
                        fullWidth
                        disabled={isEdit}
                        inputProps={{ min: 1, max: MAX_CREDIT_DAYS }}
                        helperText={
                          isEdit
                            ? "Approved by Admin for this document"
                            : "Admin can adjust the days"
                        }
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <TextField
                        label="Due Date"
                        value={
                          formik.values.dueDate
                            ? dayjs(formik.values.dueDate).format("DD-MM-YYYY")
                            : ""
                        }
                        helperText="Calculated from the credit days"
                        fullWidth
                        disabled
                      />
                    </Grid>
                  </>
                )}

                {/* One clear status line for the situation, full width. */}
                {!isEdit && (advanceCoversTotal || formik.values.payment_type == 1) && (
                  <Grid item xs={12}>
                    {advanceCoversTotal ? (
                      <Alert severity="success" sx={{ borderRadius: 1.5 }}>
                        <Typography variant="body2" sx={{ fontWeight: 700 }}>
                          Paid in full by advance — switched to Immediate Payment.
                        </Typography>
                        <Typography variant="body2">
                          This CDN is created straight away as fully paid, with no Admin approval. Credit isn't
                          available while the advance covers the full amount; reduce the advance to use credit.
                        </Typography>
                      </Alert>
                    ) : advancePartial ? (
                      <Alert severity="info" icon={<InfoOutlinedIcon fontSize="small" />} sx={{ borderRadius: 1.5 }}>
                        <Typography variant="body2" sx={{ fontWeight: 700 }}>
                          Credit applies only to the balance of {formatAED(creditBalance)}.
                        </Typography>
                        <Typography variant="body2">
                          Grand Total {formatAED(grandTotalNum)} − advance {formatAED(advanceEntered)}.
                          The credit terms need approval from Admin.
                        </Typography>
                      </Alert>
                    ) : (
                      <Alert severity="info" icon={<InfoOutlinedIcon fontSize="small" />} sx={{ borderRadius: 1.5 }}>
                        <Typography variant="body2" sx={{ fontWeight: 600 }}>
                          Credit needs approval from Admin.
                        </Typography>
                      </Alert>
                    )}
                  </Grid>
                )}

                {/* Why credit is being requested — shown to Admin next to the
                    document in the approval list, separate from Notes. */}
                {formik.values.payment_type == 1 && !isEdit && (
                  <Grid item xs={12}>
                    <TextField
                      label="Reason for Credit Request (optional)"
                      placeholder="e.g. regular customer, first order on credit, etc."
                      value={creditReason}
                      onChange={(e) => setCreditReason(e.target.value)}
                      fullWidth
                      size="small"
                      multiline
                      rows={2}
                    />
                  </Grid>
                )}

                {/* Advance payments received while creating the CDN (CDN only). */}
                {variant === "cdn" && !isEdit && (
                  <Grid item xs={12}>
                    <Box sx={{ border: "1px solid #E3E6EA", borderRadius: "12px", bgcolor: "#FAFBFC", p: 2 }}>
                      <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 2, mb: 1.5 }}>
                        <Box>
                          <Typography sx={{ fontWeight: 700, fontSize: 14 }}>Advance Payment</Typography>
                          <Typography variant="body2" color="text.secondary" sx={{ fontSize: 12.5 }}>
                            Optional — money the customer has already paid. Add one row per payment.
                          </Typography>
                        </Box>
                        <Button
                          size="small"
                          variant="outlined"
                          startIcon={<AddCircleOutlineIcon fontSize="small" />}
                          sx={{ flexShrink: 0, textTransform: "none" }}
                          onClick={() =>
                            formik.setFieldValue("advances", [
                              ...(formik.values.advances || []),
                              { payment_method: "", amount: "", transaction_id: "", attachment_url: "", attachment_name: "", uploading: false },
                            ])
                          }
                        >
                          Add advance
                        </Button>
                      </Box>

                      {(formik.values.advances || []).length === 0 && (
                        <Typography variant="body2" color="text.disabled" sx={{ py: 0.5 }}>
                          No advance received.
                        </Typography>
                      )}

                      {(formik.values.advances || []).map((adv, i) => {
                        const setAdv = (patch) =>
                          formik.setFieldValue(
                            "advances",
                            formik.values.advances.map((a, j) => (j === i ? { ...a, ...patch } : a))
                          );
                        return (
                          <Box
                            key={i}
                            sx={{ border: "1px solid #E3E6EA", borderRadius: "10px", bgcolor: "#fff", p: 1.5, mb: 1.5 }}
                          >
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1.25 }}>
                              <Typography sx={{ fontWeight: 600, fontSize: 13 }}>Advance {i + 1}</Typography>
                              <Tooltip title="Remove this advance" arrow>
                                <IconButton
                                  size="small"
                                  onClick={() =>
                                    formik.setFieldValue(
                                      "advances",
                                      formik.values.advances.filter((_, j) => j !== i)
                                    )
                                  }
                                >
                                  <DeleteOutlineOutlinedIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            </Box>
                            <Grid container spacing={1.5}>
                              <Grid item xs={12} sm={4}>
                                <TextField
                                  select
                                  fullWidth
                                  size="small"
                                  label="Method"
                                  value={adv.payment_method}
                                  onChange={(e) => setAdv({ payment_method: e.target.value })}
                                >
                                  {paymentOptions.map((opt) => (
                                    <MenuItem key={opt.value} value={opt.value}>
                                      {opt.label}
                                    </MenuItem>
                                  ))}
                                </TextField>
                              </Grid>
                              <Grid item xs={12} sm={3}>
                                <TextField
                                  fullWidth
                                  size="small"
                                  type="number"
                                  label="Amount (AED)"
                                  value={adv.amount}
                                  onChange={(e) => setAdv({ amount: e.target.value })}
                                />
                              </Grid>
                              <Grid item xs={12} sm={5}>
                                <TextField
                                  fullWidth
                                  size="small"
                                  label="Reference No."
                                  value={adv.transaction_id}
                                  onChange={(e) => setAdv({ transaction_id: e.target.value })}
                                />
                              </Grid>
                              <Grid item xs={12}>
                                <PaymentAttachmentUpload
                                  height={48}
                                  label="Attach payment proof (optional)"
                                  url={adv.attachment_url}
                                  name={adv.attachment_name}
                                  uploading={adv.uploading}
                                  uploadApi={uploadToVercelAPI}
                                  onUploadStart={() => setAdv({ uploading: true })}
                                  onUploadSuccess={({ url, name }) =>
                                    setAdv({ attachment_url: url, attachment_name: name, uploading: false })
                                  }
                                  onUploadError={(message) => {
                                    setAdv({ uploading: false });
                                    alertRef.current?.triggerAlert(
                                      JSON.stringify({ message, messageType: "error" })
                                    );
                                  }}
                                  onRemove={() => setAdv({ attachment_url: "", attachment_name: "" })}
                                />
                              </Grid>
                            </Grid>
                          </Box>
                        );
                      })}

                      {(formik.values.advances || []).length > 0 && (
                        <>
                          <Grid container spacing={1.5}>
                            {[
                              { label: "Grand Total", value: grandTotalNum, color: "text.primary" },
                              { label: "Advance Received", value: advanceEntered, color: advanceEntered > grandTotalNum + 0.009 ? "error.main" : "success.main" },
                              { label: "Balance Due", value: Math.max(0, grandTotalNum - advanceEntered), color: grandTotalNum - advanceEntered > 0.009 ? "warning.dark" : "success.main" },
                            ].map((t) => (
                              <Grid item xs={12} sm={4} key={t.label}>
                                <Box sx={{ border: "1px solid #E3E6EA", borderRadius: "8px", px: 1.5, py: 1, bgcolor: "#fff" }}>
                                  <Typography sx={{ fontSize: 12, color: "text.secondary" }}>{t.label}</Typography>
                                  <Typography sx={{ fontSize: 16, fontWeight: 700, color: t.color }}>
                                    {formatAED(t.value)}
                                  </Typography>
                                </Box>
                              </Grid>
                            ))}
                          </Grid>
                          {advanceEntered > grandTotalNum + 0.009 && (
                            <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                              The advance cannot be more than the Grand Total.
                            </Typography>
                          )}
                        </>
                      )}
                    </Box>
                  </Grid>
                )}

                {/* Notes */}
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    multiline
                    rows={2}
                    label="Notes"
                    name="notes"
                    value={formik.values.notes}
                    onChange={(e) => {
                      let value = e.target.value;
                      value = value.charAt(0).toUpperCase() + value.slice(1);
                      formik.setFieldValue("notes", value);
                    }}
                  />
                </Grid>
              </Grid>

            </Box>

            {/* Terms and Conditions */}
            <Box
              sx={{
                border: "1px solid #E3E6EA",
                borderRadius: "14px",
                p: { xs: 2, sm: 3.5 },
                mb: 3,
                backgroundColor: "#fff",
                boxShadow: "0 1px 2px rgba(16,24,40,0.04)",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1.25,
                  mb: 2.5,
                }}
              >
                <Box
                  sx={{
                    width: 26,
                    height: 26,
                    borderRadius: "7px",
                    bgcolor: "#EEF2FF",
                    color: "#2F5FED",
                    fontSize: 12,
                    fontWeight: 700,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  5
                </Box>
                <Typography sx={{ fontWeight: 700, fontSize: 15 }}>
                  Terms & Conditions
                </Typography>
              </Box>
              <Grid
                item
                xs={12}
                md={4}
                lg={4}
                textAlign="left"
                className="po_lebleterm"
              >
                <FormControl
                  className="form_control"
                  sx={{ width: "100%" }}
                  error={formik.touched.term_id && Boolean(formik.errors.term_id)} // put error on FormControl
                >
                  <Select
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    value={formik.values.term_id}
                    onChange={(event) => {
                      formik.setFieldValue("term_id", event.target.value);
                      const terms = termsAndConditions.find(
                        (term) => term.id === event.target.value
                      );
                      formik.setFieldValue("terms", terms?.description || "");
                    }}
                    input={<OutlinedInput />}
                  >
                    {termsAndConditions?.map((terms) => (
                      <MenuItem key={terms?.id} value={terms?.id}>
                        <ListItemText primary={terms?.title} />
                      </MenuItem>
                    ))}
                  </Select>

                  {/* This is where the error text shows */}
                  {formik.touched.term_id && formik.errors.term_id && (
                    <FormHelperText>{formik.errors.term_id}</FormHelperText>
                  )}
                </FormControl>
              </Grid>
              {formik.values.terms !== "" && (
                <Grid item lg={12} md={12} sm={12} mt={2}>
                  <ReactQuill
                    theme="snow"
                    value={formik.values.terms}
                    onChange={(content) => formik.setFieldValue("terms", content)} // Store as HTML
                    style={{ height: "200px", marginBottom: "40px" }}
                  />
                  {formik.touched.terms && formik.errors.terms && (
                    <p style={{ color: "red", fontSize: "12px" }}>
                      {formik.errors.terms}
                    </p>
                  )}
                </Grid>
              )}
            </Box>

            {/* Submit */}
            <Box display="flex" justifyContent="flex-end" mt={1}>
              <Button
                onClick={handleSubmitWithValidation}
                variant="contained"
                color="primary"
                disabled={loading}
                sx={{ px: 4, py: 1.25, borderRadius: 2, fontWeight: 700 }}
              >
                {isEdit ? cfg.submitButtonUpdate : cfg.submitButtonCreate}
              </Button>
            </Box>
          </Box>
        </form>
      </Grid>
    </Layout>
  );
};

export default DeliveryNoteForm;
